// French translations
export const fr = {
  // Common
  common: {
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    confirm: "Confirmer",
    save: "Enregistrer",
    delete: "Supprimer",
    remove: "Retirer",
    edit: "Modifier",
    view: "Voir",
    add: "Ajouter",
    search: "Rechercher",
    filter: "Filtrer",
    export: "Exporter",
    import: "Importer",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    yes: "Oui",
    no: "Non",
    at: "à",
    or: "ou",
    and: "et",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    phone: "Téléphone",
    date: "Date",
    type: "Type",
    status: "Statut",
    page: "Page",
    actions: "Actions",
    settings: "Paramètres",
    preferences: "Préférences",
    language: "Langue",
    languageCode: "fr",
    day: "jour",
    days: "jours",
    hour: "heure",
    hours: "heures",
    minutes: "minutes",
    week: "semaine",
    weeks: "semaines",
    month: "mois",
    months: "mois",
    inactive: "Inactif",
    sending: "Envoi en cours...",
    copy: "Copier",
    more: "autres",
    tomorrow: "Demain",
    refresh: "Actualiser",
    menu: "Menu",
    clearFilters: "Réinitialiser"
  },
  
  // Pagination
  pagination: {
    showing: "Affichage de",
    to: "à",
    of: "sur",
    results: "résultats"
  },
  
  // Days of the week
  days: {
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    // Short versions
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim"
  },
  
  // Navigation - Public Header
  navigation: {
    home: "Accueil",
    about: "Qui sommes-nous",
    features: "Fonctionnalités",
    pricing: "Tarification",
    contact: "Contact",
    login: "Connexion",
    signup: "Inscription",
    dashboard: "Tableau de bord"
  },

  brand: {
    slogan: "Moins de tri. Plus de talent."
  },

  industries: {
    technology: "Technologie",
    financial_services: "Services financiers",
    healthcare_life_sciences: "Santé et sciences de la vie",
    education: "Éducation",
    retail_ecommerce: "Commerce de détail et e-commerce",
    manufacturing: "Industrie manufacturière",
    professional_services_consulting: "Services professionnels et conseil",
    media_marketing_advertising: "Médias, marketing et publicité",
    telecommunications: "Télécommunications",
    transportation_logistics: "Transport et logistique",
    energy_utilities: "Énergie et services publics",
    government_public_sector: "Secteur public et gouvernemental",
    non_profit: "Organisme à but non lucratif",
    real_estate_construction: "Immobilier et construction",
    hospitality_travel: "Hôtellerie et voyage",
    legal: "Services juridiques",
    human_resources_staffing: "Ressources humaines et recrutement",
    other: "Autre"
  },

  // Language Selector
  languages: {
    french: "Français",
    english: "English",
    spanish: "Español",
    selectLanguage: "Choisir la langue"
  },

  // About Page
  about: {
    title: "À propos de Candio",
    subtitle: "La solution IA pour automatiser votre sélection de candidats",
    content: {
      introduction: "Candio est une plateforme SaaS innovante qui révolutionne le processus de recrutement en utilisant l'intelligence artificielle pour analyser et comparer automatiquement des CVs par rapport à des offres d'emploi."
    },
    mission: {
      title: "Notre Mission",
      description: "Nous aidons les sociétés de services TI et les cabinets RH à gagner du temps et à améliorer la qualité de leurs recrutements grâce à une analyse objective et précise des candidatures."
    }
  },

  // Home Page
  home: {
    hero: {
      badge: "Solution #1 pour les équipes RH IT",
      complianceBadge: "AI Act Proof • Conforme RGPD",
      title: "Arrêtez de trier les CVs.",
      titleHighlight: "Commencez à présélectionner les bons candidats.",
      subtitle: "Nous gérons le premier tri.",
      subtitleHighlight: "Vous vous concentrez sur le bon recrutement.",
      ctaBeta: "Accès bêta",
      ctaPricing: "Voir les tarifs",
      guarantees: {
        instant: "Configuration immédiate",
        noCard: "Pas de carte bancaire",
        support: "Support inclus"
      },
      whiteboard: {
        notes: {
          screening: {
            title: "Shortlist du matin",
            body: "Valider les 5 meilleurs CVs avant 10h et envoyer la shortlist au manager."
          },
          followup: {
            title: "Relance candidats",
            body: "Appeler les candidats sans réponse et confirmer les disponibilités d'entretien."
          },
          interview: {
            title: "Préparation entretien",
            body: "Aligner les critères de scorecard avec l'équipe avant les entretiens."
          },
          feedback: {
            title: "Boucle de feedback",
            body: "Collecter les retours d'entretien sous 2h pour garder le pipeline fluide."
          },
          pipeline: {
            title: "Revue pipeline",
            body: "Vérifier les étapes bloquées et faire avancer les profils prioritaires."
          },
          sla: {
            title: "SLA de réponse",
            body: "Maintenir un délai de réponse candidat inférieur à 24h sur les candidatures actives."
          },
          sourcing: {
            title: "Sourcing du jour",
            body: "Identifier de nouveaux profils qualifiés à ajouter au pipeline actif."
          },
          sync: {
            title: "Sync équipe RH",
            body: "Aligner les priorités de recrutement avec les managers en début de journée."
          },
          calendar: {
            title: "Bloc agenda",
            body: "Réserver des créneaux d'entretien pour éviter les délais de planification."
          },
          debrief: {
            title: "Debrief entretien",
            body: "Centraliser les retours de panel juste après chaque entretien."
          },
          response: {
            title: "Relance candidate",
            body: "Confirmer la réception des candidatures et maintenir une réponse rapide."
          },
          pipelineHealth: {
            title: "Santé pipeline",
            body: "Repérer les étapes bloquées et équilibrer la charge par offre."
          }
        }
      },
      demo: {
        analyzing: "Analyse IA en cours...",
        cvCount: "150 CVs",
        completed: "Analyse terminée en 3 min 24s",
        timeSaved: "90% de temps économisé",
        recommended: "Recommandé",
        toConsider: "À considérer",
        aiScore: "Score IA 9,2/10",
        matchRate: "Taux de matching 92%"
      },
      visual: {
        title: "Moteur de matching",
        offerTitle: "Offre",
        offerRole: "Ingénieur Data",
        scoreLabel: "Score global",
        matchLabel: "Offre vs candidats",
        breakdown: {
          skills: "Compétences",
          experience: "Expérience",
          culture: "Culture fit"
        },
        candidatesTitle: "Candidats prioritaires",
        candidates: {
          one: "Amel",
          two: "Karim",
          three: "Lina",
          role1: "Ingénieure Data Senior",
          role2: "Ingénieur ML",
          role3: "Analyste Data"
        }
      }
    },
    painPoints: {
      badge: "Les défis quotidiens des équipes RH",
      title: "Vous reconnaissez-vous dans ces situations ?",
      subtitle: "80% des professionnels RH perdent un temps précieux sur des tâches répétitives au lieu de se concentrer sur l'humain",
      timeWasting: {
        title: "Tri manuel chronophage",
        description: "Vous passez 80% de votre temps à trier manuellement des CVs au lieu de vous concentrer sur l'entretien et la relation candidat."
      },
      bias: {
        title: "Risque de biais inconscient",
        description: "La sélection manuelle peut introduire des biais involontaires qui nuisent à la diversité et à l'équité de vos recrutements."
      },
      inconsistency: {
        title: "Processus non standardisé",
        description: "Chaque recruteur applique ses propres critères, créant des incohérences dans l'évaluation des candidats."
      },
      tracking: {
        title: "Difficulté à suivre les KPIs",
        description: "Impossible de mesurer l'efficacité de vos processus RH et d'optimiser vos performances de recrutement."
      },
      preview: {
        fileTitle: "Dossier-candidature.docx",
        documentType: "Document DOCX",
        context: "Contexte opérationnel RH",
        noteLabel: "Impact terrain",
        lastUpdated: "Mise à jour: aujourd'hui",
        signature: "Note RH quotidienne — candio"
      },
      conclusion: "Et si vous pouviez transformer ces défis en avantages concurrentiels ?",
      solution: "Candio automatise le tri pour libérer votre temps et votre créativité"
    },
    process: {
      badge: "Workflow automatisé et intelligent",
      title: "6 étapes pour révolutionner votre recrutement",
      subtitle: "Un processus simple et fluide qui élimine 90% des tâches répétitives",
      before: "Avant",
      beforeTime: "8h de travail",
      now: "Maintenant",
      nowTime: "6 minutes",
      steps: {
        connection: {
          title: "Connexion & Création d'Offre",
          description: "Connectez-vous et créez votre offre d'emploi avec les critères spécifiques. Fini les templates complexes.",
          time: "3 min",
          oldWay: "❌ Rédaction manuelle, copier-coller, multiples plateformes",
          features: {
            secure: "Interface sécurisée",
            fast: "Création rapide",
            ready: "Prêt en 3 min"
          }
        },
        sharing: {
          title: "Publication & Partage",
          description: "Publiez et partagez votre offre d'un clic. URL unique générée automatiquement pour tous vos canaux.",
          time: "30 sec",
          oldWay: "❌ Publication manuelle sur chaque site d'emploi",
          features: {
            link: "Lien unique généré",
            multichannel: "Partage multi-canaux",
            instant: "Publication instantanée"
          }
        },
        reception: {
          title: "Réception Centralisée",
          description: "Toutes les candidatures arrivent en un seul endroit. Plus de boîtes email dispersées ou fichiers perdus.",
          time: "Automatique",
          oldWay: "❌ Emails dispersés, téléchargements manuels",
          features: {
            centralized: "Réception centralisée",
            notifications: "Notifications temps réel",
            organization: "Organisation automatique"
          }
        },
        analysis: {
          title: "Analyse IA & Classement",
          description: "L'IA analyse et classe automatiquement tous les CVs par ordre de pertinence. Du plus recommandé au moins adapté.",
          time: "2 min pour 100 CVs",
          oldWay: "❌ 8h de lecture manuelle, risque d'erreurs",
          features: {
            ai: "IA analyse les CVs",
            score: "Score de compatibilité",
            ranking: "Classement automatique"
          }
        },
        generation: {
          title: "Génération Fiche Candidat",
          description: "Transformez le CV du candidat recommandé en fiche structurée avec l'IA. Toutes les infos clés extraites.",
          time: "10 sec",
          oldWay: "❌ Saisie manuelle, reformatage, copier-coller",
          features: {
            extraction: "Extraction des données",
            summary: "Résumé intelligent",
            complete: "Fiche candidat complète"
          }
        },
        tracking: {
          title: "Suivi Kanban",
          description: "Envoyez la fiche vers le tableau Kanban et pilotez le processus de recrutement jusqu'à l'embauche.",
          time: "1 clic",
          oldWay: "❌ Tableaux Excel, emails de suivi manuels",
          features: {
            kanban: "Tableau Kanban visuel",
            follow: "Suivi du processus",
            hire: "Jusqu'à l'embauche"
          }
        }
      },
      comparison: {
        title: "Récapitulatif : Votre gain de temps",
        subtitle: "Pour un processus de recrutement de 100 candidatures",
        traditional: "❌ Méthode Traditionnelle",
        candio: "✅ Avec Candio",
        tasks: {
          creation: "Création offre + publication",
          collection: "Collecte des candidatures", 
          automated: "Collecte automatisée",
          sorting: "Lecture + tri 100 CVs",
          aiSorting: "Analyse IA + tri 100 CVs",
          sheets: "Création fiches candidats",
          aiSheets: "Génération fiches IA",
          organization: "Organisation + suivi",
          kanbanSend: "Envoi vers Kanban"
        },
        total: "TOTAL",
        gain: "Gain : 13h 54min",
        percentage: "Soit 99.3% de temps économisé !",
        cta: "Tester ce workflow maintenant"
      },
      traditionalMethod: "Méthode traditionnelle :",
      // Process Simplified
      simplified: {
        badge: "Processus optimisé",
        title: "Simplifiez votre recrutement en 4 étapes",
        subtitle: "Concentrez-vous sur l'essentiel : rencontrer les meilleurs candidats",
        traditional: "Méthode traditionnelle",
        traditionalTime: "14 heures",
        withCandio: "Avec Candio",
        candioTime: "6 minutes",
        savings: "Temps économisé :",
        upload: {
          title: "Créez et publiez",
          description: "Créez votre offre et partagez-la en quelques clics"
        },
        share: {
          title: "Collectez facilement", 
          description: "Recevez et centralisez toutes les candidatures automatiquement"
        },
        analyze: {
          title: "Analysez avec l'IA",
          description: "Obtenez un classement objectif des candidats en 2 minutes"
        },
        select: {
          title: "Sélectionnez et suivez",
          description: "Gérez vos candidats retenus dans un tableau visuel"
        },
        cta: "Prêt à transformer votre processus de recrutement ?",
        ctaButton: "Accès bêta"
      }
    },
    // Appointments Section
    appointments: {
      badge: "Nouvelle fonctionnalité",
      title: "Automatisez vos prises de rendez-vous",
      subtitle: "Connectez vos outils de visioconférence préférés et laissez les candidats réserver leurs créneaux",
      features: {
        calendar: {
          title: "Calendrier intelligent",
          description: "Définissez vos disponibilités et laissez les candidats choisir"
        },
        candidates: {
          title: "Invitations automatiques",
          description: "Envoyez des invitations personnalisées en un clic"
        },
        video: {
          title: "Multi-plateformes",
          description: "Compatible avec vos outils de visio préférés"
        }
      },
      howItWorks: {
        title: "Comment ça marche ?",
        step1: {
          title: "Configurez vos outils",
          description: "Connectez Teams, Zoom, Meet ou Slack"
        },
        step2: {
          title: "Définissez vos créneaux",
          description: "Indiquez vos disponibilités"
        },
        step3: {
          title: "Laissez faire la magie",
          description: "Les candidats réservent et reçoivent le lien automatiquement"
        }
      },
      cta: "Découvrir la prise de rendez-vous"
    },
    features: {
      title: "Fonctionnalités pensées pour les RH",
      subtitle: "Chaque fonctionnalité répond à un besoin concret de votre quotidien",
      aiAnalysis: {
        title: "Analyse IA Objective",
        description: "Éliminez les biais avec une évaluation standardisée basée sur des critères métiers précis et mesurables.",
        benefit: "95% de précision"
      },
      timeGain: {
        title: "Gain de Temps Massif",
        description: "Traitez 500+ CVs par heure vs 20 manuellement. Concentrez-vous sur l'humain, pas sur le tri.",
        benefit: "90% de temps économisé"
      },
      collaboration: {
        title: "Collaboration RH Fluide",
        description: "Kanban interactif, notes partagées et workflow unifié pour une équipe RH alignée et efficace.",
        benefit: "100% de visibilité"
      },
      datadriven: {
        title: "Pilotage Data-Driven",
        description: "Tableaux de bord en temps réel pour mesurer vos KPIs RH et optimiser vos processus.",
        benefit: "ROI démontré"
      }
    },
    roi: {
      badge: "ROI démontré dès le premier mois",
      title: "Des bénéfices mesurables pour votre équipe RH",
      subtitle: "Nos clients constatent un retour sur investissement immédiat avec des gains quantifiables",
      stats: {
        timesSaved: "Temps de tri économisé",
        cvsHour: "CVs analysés/heure",
        precision: "Précision d'analyse",
        availability: "Disponibilité"
      },
      benefits: {
        measurableRoi: {
          title: "ROI Mesurable",
          description: "Réduction de 70% du coût par recrutement grâce à l'automatisation du tri.",
          value: "70% d'économies"
        },
        quality: {
          title: "Qualité Supérieure",
          description: "Sélection plus précise avec scoring objectif et élimination des biais.",
          value: "40% de meilleurs matchs"
        },
        timeToHire: {
          title: "Time-to-Hire Optimisé",
          description: "Réduction drastique du temps entre publication et première sélection.",
          value: "60% plus rapide"
        },
        satisfaction: {
          title: "Satisfaction Équipe",
          description: "Vos RH se concentrent sur l'humain et la stratégie, pas sur le tri.",
          value: "85% de satisfaction"
        }
      },
      calculator: {
        title: "Calculez votre ROI en 30 secondes",
        subtitle: "Combien de temps votre équipe passe-t-elle à trier des CVs chaque semaine ? Découvrez vos économies potentielles avec Candio.",
        ctaCalculate: "Calculer mon ROI",
        ctaDemo: "Demander une présentation",
        roiValue: "3.2x",
        roiDescription: "ROI moyen constaté dès le premier mois"
      }
    },
    testimonials: {
      badge: "Témoignages clients vérifiés",
      title: "Ils ont transformé leur recrutement",
      subtitle: "Découvrez comment les équipes RH utilisent Candio pour révolutionner leurs processus",
      testimonial1: {
        name: "Marie Dubois",
        role: "Directrice RH",
        company: "TechCorp Solutions",
        content: "Candio a révolutionné notre processus de recrutement. Nous traitons maintenant 10 fois plus de candidatures avec la même équipe RH. Le ROI est évident dès le premier mois.",
        result: "300% d'efficacité en plus"
      },
      testimonial2: {
        name: "Pierre Martin", 
        role: "Consultant Senior",
        company: "HR Excellence",
        content: "L'analyse IA est impressionnante de précision. Nos clients sont ravis de la qualité des pré-sélections. Plus de biais, plus d'erreurs.",
        result: "95% de précision"
      },
      testimonial3: {
        name: "Sophie Chen",
        role: "Responsable Recrutement",
        company: "DevTech Partners",
        content: "Avant Candio, nous passions 80% de notre temps à trier. Maintenant, nous nous concentrons sur l'humain et la stratégie RH.",
        result: "80% de temps libéré"
      },
      stats: {
        rating: "Note moyenne",
        customers: "Clients satisfaits",
        retention: "Taux de rétention"
      }
    },
    community: {
      badge: "Communauté de lancement",
      title: "Soutenez Candio pendant notre phase de lancement",
      subtitle: "Candio est actuellement en phase de test. Rejoignez la liste pour suivre le lancement officiel et soutenir une solution 100% québécoise.",
      points: {
        testing: "Accès prioritaire aux annonces de lancement et aux grandes étapes produit.",
        support: "Soutenez concrètement le produit en rejoignant notre communauté.",
        quebec: "Une solution technologique RH fièrement conçue au Québec."
      },
      form: {
        label: "Rejoindre la liste de lancement",
        placeholder: "nom@entreprise.com",
        cta: "Rejoindre la communauté",
        loading: "Inscription...",
        success: "Merci! Votre email a été ajouté à la liste de lancement.",
        error: "Impossible d'ajouter votre email pour le moment. Veuillez réessayer.",
        invalidEmail: "Veuillez saisir une adresse email valide.",
        disclaimer: "Nous envoyons uniquement les infos utiles du lancement. Aucun spam."
      }
    },
    cta: {
      badge: "Programme bêta en cours",
      title: "Prêt à libérer 90% de votre temps",
      titleHighlight: "de tri de CVs ?",
      subtitle: "Rejoignez les équipes RH qui ont déjà transformé leur recrutement.",
      subtitleHighlight: "Installation en 5 minutes • Résultats dès la première semaine",
      button: "Accès bêta",
      guarantees: {
        trial: "7 jours gratuits, sans engagement",
        instant: "Configuration immédiate", 
        support: "Support dédié inclus"
      }
    },
    footer: {
      description: "Moins de tri. Plus de talent.",
      product: {
        title: "Produit",
        features: "Fonctionnalités",
        pricing: "Inscription",
        api: "API"
      },
      company: {
        title: "Entreprise",
        about: "À propos",
        contact: "Contact",
        careers: "Carrières"
      },
      support: {
        title: "Support",
        documentation: "Documentation",
        guides: "Guides",
        security: "Sécurité et confidentialité"
      },
      copyright: "&copy; 2025 Candio. Tous droits réservés."
    }
  },

  // Features Page
  features: {
    title: "Fonctionnalités Puissantes pour le Recrutement Moderne",
    subtitle: "Tout ce dont vous avez besoin pour rationaliser votre processus d'embauche",
    
    // Hero section
    heroTitle: "Fonctionnalités",
    heroTitleHighlight: "Innovantes",
    heroSubtitle: "Découvrez une suite complète d'outils de recrutement conçue pour simplifier et optimiser votre processus de sélection des talents.",
    
    // Main features sections
    needsTitle: "Tout ce dont vous avez besoin",
    needsSubtitle: "Une plateforme complète qui couvre tous les aspects du recrutement moderne",
    whyChooseTitle: "Pourquoi choisir notre solution ?",
    whyChooseSubtitle: "Des avantages concrets qui transforment votre façon de recruter",
    processTitle: "Un processus simplifié",
    processSubtitle: "De la publication d'offre à l'embauche, un workflow optimisé",
    ctaTitle: "Prêt à transformer votre recrutement ?",
    ctaSubtitle: "Rejoignez les entreprises qui ont déjà révolutionné leur processus de recrutement",
    ctaStartNow: "Accés beta",
    ctaContact: "Nous contacter",
    
    // Database feature
    database: {
      title: "CVthèque Centralisée",
      description: "Organisez et gérez votre base de données de candidats dans un espace unifié avec des outils de recherche avancés.",
      benefits: {
        import: "Import multiple",
        organization: "Organisation intelligente",
        search: "Recherche rapide"
      }
    },
    
    // Offer management
    offerManagement: {
      title: "Gestion d'Offres",
      description: "Créez, publiez et gérez vos offres d'emploi avec des outils modernes de diffusion et de suivi.",
      benefits: {
        creation: "Création simplifiée",
        publication: "Publication multi-canal",
        tracking: "Suivi des performances"
      }
    },
    
    // Application centralization
    applicationCentralization: {
      title: "Centralisation Candidatures",
      description: "Collectez automatiquement toutes les candidatures et gérez-les depuis une interface unifiée.",
      benefits: {
        collection: "Collection automatique",
        sorting: "Tri intelligent",
        notifications: "Notifications temps réel"
      }
    },
    
    // Recruitment tracking
    recruitmentTracking: {
      title: "Suivi de Recrutement",
      description: "Visualisez et gérez le processus de recrutement avec des outils collaboratifs intuitifs.",
      benefits: {
        visual: "Interface visuelle",
        collaboration: "Collaboration équipe",
        tracking: "Suivi étapes"
      }
    },
    
    // Notes management
    notesManagement: {
      title: "Gestion des Notes",
      description: "Partagez des notes et commentaires avec votre équipe pour une collaboration optimale.",
      benefits: {
        shared: "Notes partagées",
        realtime: "Collaboration temps réel",
        history: "Historique complet"
      }
    },
    
    // AI Matching (existing)
    aiMatching: {
      title: "Comparateur IA",
      description: "Analysez et comparez les candidatures avec des algorithmes avancés pour optimiser vos décisions.",
      benefits: {
        automatic: "Analyse automatique",
        intelligent: "Comparaison intelligente",
        decision: "Aide à la décision"
      }
    },
    
    // Appointment booking
    appointmentBooking: {
      title: "Prise de Rendez-vous",
      description: "Simplifiez la planification des entretiens avec un système de réservation en ligne comme Calendly, intégré pour les RH.",
      benefits: {
        calendar: "Calendrier intelligent",
        automation: "Réservation automatique",
        videoIntegration: "Visio intégrée"
      }
    },
    
    // Benefits section
    benefits: {
      timeGain: {
        title: "Gain de Temps",
        description: "Automatisez les tâches répétitives et concentrez-vous sur l'humain"
      },
      precision: {
        title: "Précision Accrue",
        description: "Trouvez les meilleurs candidats grâce à l'intelligence artificielle"
      },
      security: {
        title: "Sécurité Garantie",
        description: "Vos données sont protégées avec les plus hauts standards de sécurité"
      },
      accessibility: {
        title: "Accessibilité",
        description: "Accédez à votre plateforme depuis n'importe où, à tout moment"
      }
    },
    
    // Stats section
    stats: {
      timeReduction: "Réduction du temps de tri",
      precisionImprovement: "Amélioration de la précision",
      processAcceleration: "Accélération du processus",
      userSatisfaction: "Satisfaction utilisateur"
    },
    outcomes: {
      title: "Résultats mesurés",
      subtitle: "Des preuves concrètes issues de l’usage quotidien"
    },
    
    // Process steps
    processSteps: {
      publication: {
        title: "Publication",
        description: "Créez et diffusez vos offres"
      },
      collection: {
        title: "Collection",
        description: "Recevez les candidatures"
      },
      analysis: {
        title: "Analyse",
        description: "Évaluez avec l'IA"
      },
      selection: {
        title: "Sélection",
        description: "Choisissez les meilleurs"
      }
    },
    
    // Legacy features for backward compatibility
    batchAnalysis: {
      title: "Analyse par Lot",
      description: "Téléchargez et analysez plusieurs CV à la fois. Obtenez des rapports complets comparant tous les candidats simultanément."
    },
    kanbanBoard: {
      title: "Gestion Tableau Kanban",
      description: "Organisez les candidats dans votre pipeline de recrutement avec notre interface intuitive par glisser-déposer."
    },
    teamCollaboration: {
      title: "Collaboration d'Équipe",
      description: "Partagez les profils de candidats, ajoutez des notes et collaborez avec vos collègues tout au long du processus d'embauche."
    },
    customBranding: {
      title: "Image de Marque Personnalisée",
      description: "Personnalisez la plateforme avec votre logo et couleurs d'entreprise pour une expérience professionnelle."
    }
  },

  // Pricing Page
  pricing: {
    title: "Choisissez Votre Plan",
    subtitle: "Tarification flexible qui évolue avec votre entreprise",
    monthly: "Mensuel",
    yearly: "Annuel",
    save: "Économisez 20%",
    popular: "Le Plus Populaire",
    free: "Gratuit",
    planNames: {
      demo: "Démo Gratuit",
      essential: "Essentiel RH",
      enterprise: "Entreprise"
    },
    demo: {
      name: "Démo",
      price: "Gratuit",
      duration: "",
      description: "Parfait pour essayer notre plateforme",
      features: [
        "10 analyses IA par mois",
        "1 utilisateur RH",
        "5 offres d'emploi",
        "50 téléchargements de CV",
        "Support de base",
        "Fonctionnalités standard"
      ],
      cta: "Commencer la Démo Gratuite"
    },
    essential: {
      name: "Essentiel",
      price: "49€",
      duration: "/mois",
      description: "Idéal pour les petites équipes",
      features: [
        "100 analyses IA par mois",
        "2 utilisateurs RH",
        "10 offres d'emploi",
        "500 téléchargements de CV",
        "Support par email",
        "Collaboration d'équipe",
        "Rapports de base"
      ],
      cta: "Choisir Essentiel"
    },
    enterprise: {
      name: "Entreprise",
      price: "149€",
      duration: "/mois",
      description: "Pour les entreprises en croissance",
      features: [
        "500 analyses IA par mois",
        "10 utilisateurs RH",
        "50 offres d'emploi",
        "2000 téléchargements de CV",
        "Support prioritaire",
        "Image de marque personnalisée",
        "Rapports avancés",
        "Stockage MinIO personnalisé"
      ],
      cta: "Choisir Entreprise"
    },
    customDescription: "Plan personnalisé pour vos besoins",
    features: {
      title: "Tous les plans incluent :",
      list: [
        "Analyse de CV par IA",
        "Gestion tableau Kanban",
        "Collaboration en temps réel",
        "Chiffrement sécurisé des données",
        "Interface responsive mobile",
        "Mises à jour régulières"
      ],
      aiAnalysis: "Analyse CV par IA",
      kanbanManagement: "Gestion tableau Kanban",
      realtimeCollaboration: "Collaboration en temps réel",
      secureEncryption: "Chiffrement sécurisé des données",
      responsiveInterface: "Interface responsive mobile",
      regularUpdates: "Mises à jour régulières",
      batchProcessing: "Traitement par lots",
      exportFormats: "Export PDF/Excel",
      searchFilters: "Filtres de recherche avancés",
      emailNotifications: "Notifications par email",
      dashboardWidgets: "Widgets de tableau de bord",
      multiLanguage: "Support multilingue",
      hrUsers: "Utilisateurs RH inclus",
      hrUsersDesc: "Nombre d'utilisateurs RH pouvant accéder au système",
      jobOffers: "Offres d'emploi actives",
      jobOffersDesc: "Nombre maximum d'offres d'emploi simultanées",
      cvUploads: "CV Uploads (dépôt interne)",
      cvUploadsDesc: "Stockage de CV pour votre base de données interne",
      aiClassifier: "Classifieur intelligent (IA)",
      aiClassifierDesc: "Analyses IA pour classer et évaluer les CV",
      aiSummary: "Résumé automatique de CV (IA)",
      aiSummaryDesc: "Génération automatique de résumés de CV",
      appointments: "Prise de rendez-vous",
      appointmentsDesc: "Système de réservation en ligne pour les candidats",
      new: "Nouveau",
      customStorage: "Stockage MinIO personnalisé",
      customStorageDesc: "Utilisez votre propre service de stockage MinIO pour les documents",
      videoAutomation: "Automatisation URL meeting",
      videoAutomationDesc: "Génération automatique des liens de visioconférence avec services tiers",
      enterprise: "Enterprise"
    },
    additionalFeatures: {
      title: "Fonctionnalités supplémentaires",
      demo: [
        "Accès limité aux fonctionnalités",
        "Données de démonstration",
        "Support communautaire"
      ],
      essential: [
        "Toutes les fonctionnalités de base",
        "Intégrations basiques",
        "Formation en ligne"
      ],
      enterprise: [
        "Toutes les fonctionnalités Premium",
        "Intégrations personnalisées",
        "Formation sur site",
        "Account manager dédié"
      ],
      tracking: "Suivi des offres et tracking",
      applications: "Gestion des candidatures reçues",
      kanban: "Tableau Kanban – suivi du recrutement",
      notes: "Notes collaboratives & partagées",
      emailSupport: "Support par mail",
      prioritySupport: "Support & intervention prioritaire"
    },
    currentPlan: "Plan actuel",
    perMonth: "mois",
    startFree: "Commencer gratuitement",
    choosePlan: "Choisir ce plan",
    redirecting: "Redirection...",
    loginRequired: "Connectez-vous pour souscrire à un abonnement",
    demoIncluded: "Le package Demo est déjà inclus avec votre compte",
    packageNotFound: "Package non trouvé",
    missingPaymentConfig: "Configuration de paiement manquante pour ce package",
    invalidPriceConfig: "Configuration de prix invalide",
    subscriptionActivated: "Abonnement activé avec succès !",
    subscriptionError: "Erreur lors de la souscription",
    premium: "Premium",
    current: "Actuel",
    needHelp: "Besoin d'aide pour choisir le bon plan ?",
    contactUs: "Contactez-nous",
    error: {
      load: "Erreur lors du chargement des forfaits"
    },
    comparison: {
      title: "Comparez nos forfaits",
      features: "Fonctionnalités",
      feature: "Fonctionnalité",
      aiAnalyses: "Analyses IA par mois",
      hrUsers: "Utilisateurs RH",
      jobOffers: "Offres d'emploi",
      cvUploads: "Téléchargements de CV",
      support: "Support",
      teamCollaboration: "Collaboration d'équipe",
      reports: "Rapports",
      customBranding: "Image de marque personnalisée",
      minioStorage: "Stockage MinIO personnalisé",
      advancedAnalytics: "Analytiques avancées",
      apiAccess: "Accès API",
      sla: "SLA garanti",
      included: "Inclus",
      notIncluded: "-",
      basic: "De base",
      email: "Par email",
      priority: "Prioritaire",
      advanced: "Avancés",
      custom: "Personnalisé"
    },
    faq: {
      title: "Questions fréquentes",
      subtitle: "Tout ce que vous devez savoir sur nos forfaits",
      changePlan: {
        question: "Puis-je changer de plan à tout moment ?",
        answer: "Oui, vous pouvez passer à un plan supérieur ou inférieur à tout moment. Les changements prennent effet immédiatement."
      },
      limits: {
        question: "Que se passe-t-il si je dépasse mes limites ?",
        answer: "Votre accès sera temporairement suspendu jusqu'au renouvellement de votre abonnement ou la mise à niveau vers un plan supérieur."
      },
      hrUsers: {
        question: "Les utilisateurs RH ont-ils accès aux mêmes fonctionnalités ?",
        answer: "Oui, les utilisateurs RH créés par un administrateur héritent automatiquement des privilèges de l'abonnement de l'administrateur."
      },
      cancel: {
        question: "Puis-je annuler mon abonnement ?",
        answer: "Oui, vous pouvez annuler votre abonnement à tout moment. Vous conserverez l'accès jusqu'à la fin de votre période de facturation."
      },
      appointments: {
        question: "Comment fonctionnent les rendez-vous ?",
        answer: "Les rendez-vous vous permettent de planifier des entretiens directement avec les candidats sélectionnés. Vous pouvez gérer votre calendrier, envoyer des invitations et suivre les confirmations depuis votre tableau de bord."
      },
      trial: {
        question: "Y a-t-il une période d'essai gratuite ?",
        answer: "Oui, notre plan Démo vous offre un accès gratuit avec 10 analyses IA par mois pour tester toutes les fonctionnalités de la plateforme sans engagement."
      }
    }
  },

  // Contact Page
  contact: {
    title: "Contactez-nous",
    subtitle: "Nous sommes là pour vous aider",
    hero: {
      title: "Contactez Notre Équipe",
      subtitle: "Une question ? Besoin d'aide ? Notre équipe d'experts est là pour vous accompagner dans votre transformation digitale RH."
    },
    form: {
      title: "Envoyez-nous un message",
      subtitle: "Remplissez le formulaire ci-dessous et nous vous répondrons rapidement.",
      name: "Nom complet",
      namePlaceholder: "Votre nom complet",
      email: "Adresse email",
      emailPlaceholder: "votre.email@entreprise.com",
      company: "Nom de l'entreprise",
      subject: "Sujet de votre demande",
      message: "Votre message",
      messagePlaceholder: "Décrivez votre demande en détail...",
      characters: "caractères",
      send: "Envoyer le message",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès ! Nous vous répondrons sous 24h.",
      errors: {
        nameRequired: "Le nom est requis",
        emailRequired: "L'email est requis",
        emailInvalid: "Email invalide",
        messageRequired: "Le message est requis",
        messageTooShort: "Le message doit contenir au moins 10 caractères",
        formValidation: "Veuillez corriger les erreurs dans le formulaire",
        sendError: "Erreur lors de l'envoi du message",
        connectionError: "Erreur de connexion. Veuillez réessayer ou nous contacter directement à hello@candio.ai"
      }
    },
    success: {
      title: "Message envoyé !",
      message: "Merci pour votre message ! Nous vous répondrons bientôt."
    },
    subjects: {
      support: {
        label: "Support Technique",
        description: "Aide, questions techniques, problèmes"
      },
      sales: {
        label: "Démo & accompagnement", 
        description: "Démo, onboarding, questions générales"
      },
      general: {
        label: "Question Générale",
        description: "Informations, partenariat, autre"
      }
    },
    info: {
      title: "Informations de Contact",
      email: {
        title: "Email",
        description: "Nous répondons sous 24h"
      },
      hours: {
        title: "Horaires de Support",
        value: "Lun-Ven 9h-18h",
        description: "Heure française (GMT+1)"
      },
      multilingual: {
        title: "Support Multilingue",
        value: "FR / EN",
        description: "Français et Anglais"
      },
      responseTime: "Nous répondons généralement sous 24 heures ouvrées."
    },
    why: {
      title: "Pourquoi nous contacter ?",
      demo: {
        title: "Démo personnalisée",
        description: "Découvrez Candio adapté à vos besoins"
      },
      support: {
        title: "Support expert",
        description: "Aide technique et accompagnement"
      },
      pricing: {
        title: "Accompagnement sur mesure",
        description: "Onboarding et conseils adaptés à votre organisation"
      },
      training: {
        title: "Formation équipe",
        description: "Onboarding et formation utilisateurs"
      }
    },
    response: {
      title: "Réponse Garantie",
      subtitle: "Nous nous engageons à répondre à tous les messages",
      sales: "Questions vente",
      support: "Support technique"
    },
    error: "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
    modal: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous aider"
    },
    validation: {
      messageRequired: "Le message est requis"
    },
    errors: {
      sendFailed: "Erreur lors de l'envoi du message"
    }
  },

  // Authentication
  auth: {
    common: {
      secure: "Sécurisé"
    },
    password: {
      show: "Afficher le mot de passe",
      hide: "Masquer le mot de passe"
    },
    // Validation errors
    validation: {
      invalidEmail: "Adresse email invalide",
      passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
      nameLength: "Le nom doit contenir entre 2 et 100 caractères",
      passwordRequired: "Mot de passe requis",
      emailRequired: "L'adresse email est requise",
      emailInvalid: "Veuillez entrer une adresse email valide",
      confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
      allFieldsRequired: "Tous les champs sont requis"
    },
    // Resend verification  
    resend: {
      userNotFoundOrVerified: "Utilisateur non trouvé ou déjà vérifié",
      success: "Email de vérification envoyé avec succès",
      failed: "Échec de l'envoi de l'email de vérification"
    },
    // General auth errors
    error: {
      tooManyAttempts: "Trop de tentatives d'authentification. Veuillez réessayer dans {{minutes}} minutes.",
      internal: "Erreur interne du serveur",
      userNotFound: "Utilisateur non trouvé"
    },
    login: {
      title: "Accédez à votre espace",
      subtitle: "Connectez-vous pour continuer.",
      helperText: "La langue et le fuseau horaire de l'espace de travail sont appliqués à l'authentification.",
      email: "Adresse email",
      password: "Mot de passe",
      or: "ou",
      forgotPassword: "Mot de passe oublié ?",
      loginButton: "Se connecter",
      noAccount: "Vous n'avez pas de compte ?",
      signUp: "Inscrivez-vous ici",
      // Login errors
      userNotFound: "Aucun compte trouvé avec cette adresse email.",
      incorrectPassword: "Mot de passe incorrect. Vérifiez votre mot de passe.",
      notVerified: "Compte non vérifié",
      notVerifiedMessage: "Veuillez vérifier votre email avant de vous connecter. Vérifiez votre boîte de réception.",
      licenseExpired: "Licence expirée",
      errors: {
        invalidCredentials: "Email ou mot de passe invalide",
        emailRequired: "L'email est requis",
        emailInvalid: "Veuillez entrer une adresse email valide",
        passwordRequired: "Le mot de passe est requis",
        userNotFound: "Aucun compte trouvé avec cette adresse email.",
        invalidPassword: "Mot de passe incorrect. Vérifiez votre mot de passe.",
        accountNotVerified: "Compte non vérifié",
        verifyEmailFirst: "Veuillez vérifier votre email avant de vous connecter. Vérifiez votre boîte de réception.",
        licenseExpired: "Licence expirée"
      }
    },
    signup: {
      title: "Créez votre espace Candio",
      subtitle: "Inscription rapide en quelques étapes.",
      fullName: "Nom complet (optionnel)",
      email: "Adresse email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordHint: "Minimum 8 caractères",
      company: "Nom de l'entreprise",
      companyPlaceholder: "Nom de votre entreprise",
      industry: "Secteur d'activité",
      industryPlaceholder: "Technologie, Santé, Finance...",
      timezone: "Fuseau horaire",
      selectTimezone: "Sélectionnez votre fuseau horaire",
      selectIndustry: "Sélectionnez votre secteur",
      signupButton: "Créer mon compte",
      hasAccount: "Déjà un compte ?",
      signIn: "Se connecter",
      helperText: "Le profil entreprise et le fuseau horaire servent à configurer les paramètres par défaut de l'espace de travail.",
      terms: "En créant un compte, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité",
      freeTrialTitle: "Essai gratuit inclus",
      freeTrialDescription: "2 jours d'accès complet • 10 analyses • Toutes les fonctionnalités",
      errors: {
        nameRequired: "Le nom complet est requis",
        nameTooShort: "Le nom doit contenir au moins 2 caractères",
        emailRequired: "L'email est requis",
        emailInvalid: "Veuillez entrer un email valide",
        passwordRequired: "Le mot de passe est requis",
        passwordTooShort: "Le mot de passe doit contenir au moins 8 caractères",
        confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
        passwordsNoMatch: "Les mots de passe ne correspondent pas",
        companyRequired: "Le nom de l'entreprise est requis",
        industryRequired: "Le secteur d'activité est requis",
        timezoneRequired: "Le fuseau horaire est requis",
        emailExists: "Cette adresse email est déjà utilisée. Essayez de vous connecter ou utilisez une autre adresse.",
        signupFailed: "Erreur lors de la création du compte",
        internalError: "Erreur interne du serveur"
      },
      success: {
        accountCreated: "Compte créé avec succès ! Veuillez vérifier votre email.",
        accountCreatedDev: "Compte créé avec succès ! (Vérification automatique en développement)",
        accountCreatedEmailFailed: "Compte créé avec succès ! La vérification par email a échoué mais le compte est activé."
      },
      passwordChecks: {
        title: "Exigences mot de passe",
        length: "Au moins 8 caractères",
        uppercase: "Une lettre majuscule",
        lowercase: "Une lettre minuscule",
        number: "Un chiffre"
      }
    },
    verification: {
      title: "Vérification Email",
      subtitle: "Nous avons envoyé un lien de vérification à votre adresse email",
      checkEmail: "Veuillez vérifier votre email et cliquer sur le lien de vérification pour compléter votre inscription.",
      checkEmailPrompt: "Votre compte n'est pas encore vérifié. Vérifiez votre email ou renvoyer un nouveau lien.",
      resend: "Renvoyer l'email de vérification",
      unverifiedAccount: "Compte non vérifié",
      backToLogin: "Retour à la connexion",
      states: {
        verifying: "Vérification en cours...",
        pleasewait: "Veuillez patienter pendant que nous vérifions votre email.",
        success: "Email vérifié avec succès !",
        accountActivated: "Votre compte a été activé. Vous pouvez maintenant vous connecter.",
        error: "Erreur de vérification",
        invalidLink: "Le lien de vérification est invalide ou a expiré.",
        alreadyVerified: "Email déjà vérifié. Vous pouvez vous connecter."
      },
      actions: {
        createNewAccount: "Créer un nouveau compte",
        tryLogin: "Essayer de se connecter"
      },
      errors: {
        missingToken: "Token de vérification manquant",
        verificationFailed: "La vérification a échoué. Veuillez réessayer.",
        tokenRequired: "Token de vérification requis",
        invalidToken: "Token de vérification invalide ou expiré",
        userNotFound: "Utilisateur non trouvé ou déjà vérifié",
        resendFailed: "Échec de l'envoi de l'email de vérification"
      },
      messages: {
        success: "Email vérifié avec succès !"
      },
      success: {
        emailSent: "Email de vérification envoyé avec succès"
      },
      help: {
        needHelp: "Besoin d'aide ?",
        contactUs: "Contactez-nous"
      }
    },
    // Email verification
    verify: {
      tokenRequired: "Token de vérification requis",
      invalidToken: "Token de vérification invalide ou expiré", 
      success: "Email vérifié avec succès. Vous pouvez maintenant vous connecter.",
      alreadyVerified: "Email déjà vérifié. Vous pouvez vous connecter."
    },
    // Forgot password
    forgotPassword: {
      title: "Mot de passe oublié ?",
      subtitle: "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe",
      emailLabel: "Adresse email",
      emailPlaceholder: "votre@email.com",
      sendResetLink: "Envoyer le lien de réinitialisation",
      backToLogin: "Retour à la connexion",
      emailSentTitle: "Email envoyé !",
      emailSentDescription: "Nous avons envoyé un lien de réinitialisation de mot de passe à {{email}}",
      checkSpam: "Si vous ne voyez pas l'email, vérifiez votre dossier spam.",
      checkEmailMessage: "Si un compte existe avec cette adresse email, vous recevrez un lien de réinitialisation de mot de passe.",
      emailSentSuccess: "Email envoyé avec succès"
    },
    // Reset password
    resetPassword: {
      title: "Réinitialiser le mot de passe",
      subtitle: "Choisissez un nouveau mot de passe sécurisé",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      resetButton: "Réinitialiser le mot de passe",
      backToLogin: "Retour à la connexion",
      invalidToken: "Lien de réinitialisation invalide ou expiré",
      successTitle: "Mot de passe réinitialisé !",
      successDescription: "Votre mot de passe a été réinitialisé avec succès",
      successMessage: "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.",
      redirectingToLogin: "Redirection vers la page de connexion..."
    },
    // Messages
    messages: {
      connectionError: "Erreur de connexion. Veuillez réessayer.",
      resendError: "Erreur lors de l'envoi de l'email",
      verificationRequired: "Vérification d'email requise",
      signupSuccess: "Compte créé avec succès ! Veuillez vérifier votre boîte courriel pour confirmer votre adresse e-mail.",
      signupError: "Erreur lors de la création du compte",
      backToHome: "Retour à l'accueil",
      newToCandio: "Nouveau sur Candio ?",
      createAccountForTrial: "Créez votre compte et bénéficiez de 2 jours d'essai gratuit",
      startFreeTrial: "Commencer l'essai gratuit"
    },
    banner: {
      login: {
        title: "Bienvenue sur Candio",
        subtitle: "La solution IA pour optimiser vos recrutements"
      },
      signup: {
        title: "Rejoignez Candio",
        subtitle: "Commencez votre essai gratuit dès aujourd'hui"
      },
      features: {
        matching: {
          title: "Matching IA précis",
          description: "Trouvez les meilleurs candidats en quelques secondes"
        },
        analytics: {
          title: "Analytics avancées",
          description: "Suivez vos performances de recrutement en temps réel"
        },
        collaboration: {
          title: "Collaboration d'équipe",
          description: "Travaillez ensemble sur vos processus de recrutement"
        }
      },
      stats: {
        companies: "Entreprises",
        cvs: "CVs analysés",
        satisfaction: "Satisfaction"
      },
      trust: {
        secure: "Données sécurisées",
        compliant: "RGPD Compliant"
      }
    }
  },

  // Dashboard
  dashboard: {
    welcome: "Bonjour",
    overview: "Vue d'ensemble",
    quickActions: "Actions rapides",
    recentActivity: "Activité récente",
    statistics: "Statistiques",
    noRecentActivity: "Aucune activité récente",
    subtitle: {
      admin: "Voici un aperçu de l'activité de votre équipe",
      hr: "Voici un aperçu de l'activité partagée de votre équipe"
    },
    plan: {
      current: "Plan",
      expired: "Expiré",
      expiredTitle: "Plan expiré",
      expiredMessage: "Votre plan {{planName}} a expiré. Renouvelez votre abonnement pour continuer à utiliser Candio."
    },
    planInfo: {
      title: "Informations du plan",
      planType: "Plan",
      demo: "Demo",
      active: "Actif",
      inactive: "Inactif",
      expiresOn: "Expire le",
      analyses: "Analyses",
      perMonth: "mois",
      offers: "Offres",
      cvs: "CVs",
      hrUsers: "Utilisateurs RH",
      activePlan: "Plan actif",
      users: "Utilisateurs",
      lastSync: "Dernière synchronisation"
    },
    workspace: {
      shared: "Workspace partagé"
    },
    roles: {
      admin: "Admin",
      hr: "RH"
    },
    actions: {
      sync: "Synchroniser",
      refresh: "Actualiser"
    },
    errors: {
      syncFailed: "Erreur lors de la synchronisation",
      general: "Erreur",
      activitiesLoadFailed: "Erreur lors du chargement des activités",
      notesLoadFailed: "Erreur lors du chargement des notes",
      quickActionsLoadFailed: "Erreur lors du chargement des actions rapides",
      calendarLoadFailed: "Erreur lors du chargement du calendrier",
      preferencesLoadFailed: "Erreur lors du chargement des préférences du tableau de bord",
      preferencesSaveFailed: "Erreur lors de l'enregistrement des préférences du tableau de bord"
    },
    pagination: {
      showing: "Affichage de",
      to: "à",
      of: "sur",
      entries: "entrées",
      previous: "Précédent",
      next: "Suivant"
    },
    
    // Navigation
    nav: {
      dashboard: "Tableau de bord",
      offers: "Offres d'emploi",
      cvs: "Banque de CVs",
      analyzer: "Analyseur IA",
      results: "Résultats",
      kanban: "Kanban",
      candidates: "Candidats",
      settings: "Paramètres",
      hrManagement: "Gestion RH",
      pricing: "Abonnement",
      notes: "Notes",
      applications: "Candidatures",
      appointments: "Rendez-vous",
      users: "Utilisateurs",
      env: "Variables",
      community: "Communauté"
    },

    // Widgets
    widgets: {
      offers: "Offres d'emploi",
      cvs: "CVs téléchargés",
      hrUsers: "Utilisateurs RH",
      analyses: "Analyses IA",
      aiResume: "Résumé IA CV",
      remaining: "{{count}} restant{{plural}}",
      limitReached: "Limite atteinte",
      recentNotes: "Notes récentes",
      addQuickNote: "Ajouter une note rapide",
      noNotes: "Aucune note pour le moment",
      createFirstNote: "Créez votre première note ci-dessus",
      shared: "Partagé",
      sharedBy: "par {{name}}",
      viewAllNotes: "Voir toutes les notes",
      quickActions: "Actions rapides",
      basedOnUsage: "Basé sur votre usage",
      noActionsAvailable: "Aucune action disponible",
      navigationError: "Erreur lors de la navigation",
      frequency: {
        once: "1 fois",
        times: "{{count}} fois",
        many: "10+ fois"
      },
      offersData: {
        title: "Offres d'emploi",
        open: "Ouvertes",
        closed: "Fermées",
        cancelled: "Annulées"
      },
      cvsData: {
        title: "CV Téléchargés",
        total: "Total",
        thisMonth: "Ce mois",
        uploaded: "Téléchargés"
      },
      analysesData: {
        title: "Analyses IA",
        used: "Utilisées",
        remaining: "Restantes",
        thisMonth: "Ce mois"
      },
      plan: {
        title: "Plan Actuel",
        upgrade: "Mettre à niveau"
      },
      ai: {
        title: "Fonctionnalités IA",
        analysesDescription: "Comparateur IA et résumé de CVs",
        resumeDescription: "Création de fiches candidats via IA",
        newBadge: "Nouveau",
        upcoming: "Prochaines fonctionnalités IA",
        comingSoon: "Bientôt disponible"
      },
      sharedCalendar: {
        title: "Calendrier partagé",
        noAppointments: "Aucun rendez-vous",
        viewAll: "Voir tous les rendez-vous"
      }
    },

    // Tabs
    tabs: {
      widgets: "Vue Widgets",
      analytics: "Vue Analytics RH"
    },

    // Analytics
    analytics: {
      filters: {
        last7Days: "7 derniers jours",
        last30Days: "30 derniers jours", 
        last90Days: "90 derniers jours",
        allOffers: "Toutes les offres"
      },
      error: {
        fetchFailed: "Erreur lors du chargement"
      },
      export: {
        inProgress: "Export en cours...",
        success: "Export réussi",
        error: "Erreur lors de l'export"
      },
      dragDrop: {
        hint: "Glissez pour réorganiser",
        reorderSuccess: "Widgets réorganisés"
      },
      empty: {
        title: "Aucune donnée disponible",
        description: "Les métriques apparaîtront ici une fois que vous aurez des données."
      },
      candidates: {
        title: "Activité Candidatures",
        subtitle: "Suivi des candidatures reçues",
        total: "Total",
        new: "Nouvelles",
        avgPerOffer: "Moyenne par offre",
        applications: "Candidatures",
        noData: "Aucune candidature pour cette période"
      },
      offers: {
        title: "Activité Offres",
        subtitle: "État de vos offres d'emploi",
        active: "Actives",
        closed: "Fermées",
        cancelled: "Annulées",
        popular: "Offres les plus populaires",
        applications: "candidatures",
        statusDistribution: "Répartition par statut",
        applicationsChart: "Candidatures par offre"
      },
      ai: {
        title: "IA & Traitement",
        subtitle: "Analyses automatisées",
        analyses: "Analyses",
        scored: "Scores",
        summaries: "Résumés",
        avgTime: "Temps moy.",
        processingEfficiency: "Efficacité du traitement IA",
        usageTrend: "Tendance d'utilisation de l'IA",
        comparator: "Comparateur",
        cvSummary: "Résumé CV",
        scoring: "Scoring"
      },
      quality: {
        title: "Qualité & Scores",
        subtitle: "Répartition des profils",
        avgScore: "Score moyen",
        highScore: "Score élevé",
        distribution: "Distribution des scores",
        candidates: "Candidats",
        noData: "Aucune analyse de score disponible"
      },
      history: {
        title: "Historique & Traçabilité",
        subtitle: "Actions et événements récents",
        totalActions: "Actions",
        exports: "Exports",
        recent: "Activités récentes",
        noData: "Aucune activité récente",
        activityByUser: "Activité par utilisateur",
        actionTypes: "Types d'actions"
      },
      actionTypes: {
        offer: "Offres",
        cv: "CVs",
        analysis: "Analyses",
        candidate: "Candidats",
        kanban: "Kanban"
      },
      noData: "Aucune donnée"
    },

    // Activity tracking
    activity: {
      title: "Activité récente",
      noActivity: "Aucune activité",
      noActivities: "Aucune activité récente",
      noRecentActivity: "Aucune activité récente",
      newActionsHint: "Les nouvelles actions apparaîtront ici",
      count: "activité",
      userFallback: "Utilisateur",
      fallback: "{{user}} a effectué une action",
      time: {
        now: "à l'instant",
        minutesAgo: "il y a {{count}} minute{{plural}}",
        hoursAgo: "il y a {{count}} heure{{plural}}",
        daysAgo: "il y a {{count}} jour{{plural}}"
      },
      types: {
        offer_created: "Offre créée",
        offer_updated: "Offre mise à jour", 
        offer_deleted: "Offre supprimée",
        offer_published: "Offre publiée",
        offer_unpublished: "Offre dépubliée",
        cv_uploaded: "CV téléchargé",
        cv_deleted: "CV supprimé",
        analysis_completed: "Analyse IA terminée",
        analysis_reanalyzed: "Analyse IA re-effectuée",
        result_exported: "Résultat exporté",
        user_login: "Connexion utilisateur",
        settings_updated: "Paramètres mis à jour"
      },
      // Templates for activity descriptions
      templates: {
        // Offres
        offer_created: "a créé l'offre \"{{title}}\"",
        offer_updated: "a modifié l'offre \"{{title}}\"",
        offer_deleted: "a supprimé l'offre \"{{title}}\"",
        offer_published: "a publié l'offre \"{{title}}\"",
        offer_unpublished: "a dépublié l'offre \"{{title}}\"",
        
        // CVs
        cv_uploaded: "a téléchargé le CV \"{{filename}}\"",
        cv_deleted: "a supprimé le CV \"{{filename}}\"",
        
        // Analyses
        analysis_completed: "a terminé l'analyse de {{count}} CV(s)",
        analysis_reanalyzed: "a re-analysé {{count}} CV(s)",
        
        // Candidats
        candidate_created_manual: "a créé manuellement le candidat \"{{name}}\"",
        candidate_shared_to_kanban: "a partagé le candidat \"{{name}}\" au kanban",
        candidate_updated: "a modifié le candidat \"{{name}}\"",
        candidate_moved: "a déplacé le candidat \"{{name}}\"",
        candidate_unshared_from_kanban: "a retiré le candidat \"{{name}}\" du kanban",
        candidate_deleted: "a supprimé le candidat \"{{name}}\"",
        
        // Applications
        application_submitted: "Candidature soumise par \"{{name}}\"",
        application_viewed: "a consulté la candidature de \"{{name}}\"",
        application_status_changed: "a modifié le statut de la candidature de \"{{name}}\"",
        application_cv_downloaded: "a téléchargé le CV de \"{{name}}\"",
        application_deleted: "a supprimé la candidature de \"{{name}}\"",
        application_note_added: "a ajouté une note à la candidature de \"{{name}}\"",
        application_note_updated: "a modifié une note de la candidature de \"{{name}}\"",
        application_note_deleted: "a supprimé une note de la candidature de \"{{name}}\"",
        application_added_to_kanban: "a ajouté \"{{name}}\" au kanban",
        
        // Kanban
        kanban_column_created: "a créé la colonne \"{{name}}\"",
        kanban_column_updated: "a modifié la colonne \"{{name}}\"",
        kanban_column_deleted: "a supprimé la colonne \"{{name}}\"",
        
        // Abonnements
        subscription_upgraded: "a mis à niveau vers le plan \"{{plan}}\"",
        subscription_downgraded: "a rétrogradé vers le plan \"{{plan}}\"",
        
        // Rendez-vous
        appointment_created: "a créé un rendez-vous",
        appointment_confirmed: "a confirmé le rendez-vous avec \"{{name}}\"",
        appointment_cancelled: "a annulé le rendez-vous avec \"{{name}}\"",
        appointment_rescheduled: "a reprogrammé le rendez-vous avec \"{{name}}\"",
        appointment_reminded: "a envoyé un rappel pour le rendez-vous avec \"{{name}}\"",
        availability_created: "a ajouté un créneau de disponibilité",
        availability_updated: "a modifié sa disponibilité",
        availability_deleted: "a supprimé un créneau de disponibilité",
        send_appointment_invitation: "a envoyé une invitation de rendez-vous à \"{{name}}\"",
        appointment_booked_via_url: "rendez-vous réservé via URL par \"{{name}}\"",
        
        // Test
        test_performed: "a effectué un test système",
        
        // Paramètres
        settings_cleanup_updated: "a modifié les paramètres de nettoyage automatique",
        cleanup_manual_started: "a lancé un nettoyage manuel",
        
        // Notes
        note_shared: "a partagé la note \"{{title}}\" avec {{userNames}}",
        note_unshared: "a arrêté le partage de la note \"{{title}}\"",
        
        // Configuration email/vidéo
        create: "a créé {{actionDescription}}",
        update: "a mis à jour {{actionDescription}}",
        delete: "a supprimé {{actionDescription}}",
        send: "a envoyé {{actionDescription}}"
      },
      time: {
        now: "À l'instant",
        minutesAgo: "Il y a {{count}} minute{{plural}}",
        hoursAgo: "Il y a {{count}} heure{{plural}}",
        daysAgo: "Il y a {{count}} jour{{plural}}"
      },
      pagination: {
        info: "Page {{current}} sur {{total}} • {{showing}} de {{total_activities}} activités",
        previous: "Page précédente",
        next: "Page suivante"
      }
    },

    // Notes modal in dashboard
    notes: {
      modal: {
        createTitle: "Créer une nouvelle note",
        editTitle: "Modifier la note",
        titleLabel: "Titre de la note *",
        titlePlaceholder: "Entrez le titre de la note",
        contentLabel: "Contenu *",
        contentPlaceholder: "Décrivez votre note en détail...",
        tagsLabel: "Étiquettes",
        tagsPlaceholder: "Tapez et appuyez sur Entrée pour ajouter des étiquettes",
        tagsHelp: "Utilisez des étiquettes pour organiser vos notes",
        charactersLabel: "caractères",
        cancelButton: "Annuler",
        createButton: "Créer la note",
        updateButton: "Mettre à jour la note",
        savingLabel: "Enregistrement en cours...",
        errors: {
          titleRequired: "Le titre est requis",
          titleTooLong: "Le titre ne peut pas dépasser 255 caractères",
          contentRequired: "Le contenu est requis",
          contentTooLong: "Le contenu ne peut pas dépasser 5000 caractères",
          tagsTooLong: "Les étiquettes ne peuvent pas dépasser 500 caractères",
          saveError: "Erreur lors de la sauvegarde de la note",
          saveErrorGeneral: "Une erreur s'est produite lors de la sauvegarde"
        },
        messages: {
          createSuccess: "Note créée avec succès",
          updateSuccess: "Note mise à jour avec succès"
        }
      }
    },

    // Analyzer section
    analyzer: {
      title: "Comparateur IA",
      subtitle: "Analysez et classez vos CVs par rapport aux offres d'emploi grâce à l'intelligence artificielle",
      noOffers: "Aucune offre d'emploi disponible",
      noCvs: "Aucun CV disponible",
      createOfferFirst: "Créez d'abord une offre d'emploi",
      uploadCvsFirst: "Téléchargez d'abord des CV",
      modes: {
        title: "Mode d'analyse",
        manual: {
          title: "Mode Manuel",
          description: "Offres non publiées + CVs uploadés manuellement"
        },
        submissions: {
          title: "Mode Candidatures", 
          description: "Offres publiées + CVs reçus via candidatures"
        }
      },
      selection: {
        selectOffer: "Sélectionner une offre",
        noOfferAvailable: "Aucune offre disponible",
        manualCvs: "CVs manuels ({{count}} sélectionnés)",
        receivedCvs: "CVs reçus pour \"{{title}}\" ({{count}} sélectionnés)",
        selectOfferFirst: "Sélectionnez une offre pour voir les CVs reçus",
        analysisStatus: "• {{analyzed}} analysés, {{unanalyzed}} non analysés",
        selectAll: "Tout sélectionner",
        deselectAll: "Tout désélectionner",
        searchPlaceholder: "Rechercher des CVs...",
        analysisStatusFilter: "Statut d'analyse:",
        filterAll: "Tous les CVs",
        filterUnanalyzed: "Non analysés",
        filterAnalyzed: "Déjà analysés",
        noCvsAvailable: "Aucun CV manuel disponible",
        noCvsReceived: "Aucun CV reçu pour cette offre",
        selectOfferToSeeCvs: "Sélectionnez une offre publiée pour voir les CVs reçus"
      },
      cvLabels: {
        manual: "Manuel",
        application: "Candidature",
        textExtracted: "Texte extrait",
        textRequired: "Texte requis",
        alreadyAnalyzed: "Déjà analysé",
        published: "Publiée"
      },
      actions: {
        export: "Exporter (CSV)",
        startAnalysis: "Lancer l'analyse IA",
        analyzing: "Analyse en cours...",
        startAnalysisButton: "Démarrer l'analyse"
      },
      analysisInfo: {
        limitTitle: "Limite d'analyse IA",
        limitDescription: "Vous pouvez analyser maximum 25 CVs à la fois pour garantir une analyse de qualité optimale. Pour analyser d'autres CVs de la même offre, effectuez plusieurs analyses successives.",
        startTitle: "Lancer l'analyse IA",
        startDescription: "Analyser {{count}}/25 CV(s) pour l'offre \"{{title}}\"",
        startDescriptionEmpty: "Sélectionnez une offre et des CVs pour commencer"
      },
      results: {
        title: "Résultats de l'analyse (Classés par score)",
        viewDetails: "Voir les détails",
        sendAppointment: "Envoyer une invitation de rendez-vous",
        exportResults: "Exporter les résultats",
        noResults: "Aucun résultat d'analyse",
        detailModalTitle: "Analyse détaillée - {{name}}",
        globalScore: "Score global",
        recommendation: "Recommandation",
        rank: "Rang: #{{rank}}",
        detailedAnalysis: "Analyse détaillée",
        strengths: "Points forts", 
        weaknesses: "Points d'amélioration",
        skillsEvaluation: "Évaluation des compétences",
        skillsRadarTitle: "Analyse comparative des compétences",
        close: "Fermer"
      },
      stats: {
        analyzed: "CVs Analysés",
        recommended: "Recommandés",
        consider: "À Considérer",
        avgScore: "Score Moyen"
      },
      analysis: {
        inProgress: "Analyse en cours...",
        completed: "Analyse terminée",
        progress: "Progression",
        estimatedTime: "Temps estimé",
        analyzing: "Analyse de",
        of: "sur",
        cvs: "CV",
        cancel: "Annuler l'analyse"
      },
      reanalysisModal: {
        title: "Confirmer la re-analyse",
        confirm: "Oui, refaire l'analyse",
        cancel: "Annuler",
        partialOverlapMessage: "{{count}} CV(s) sur {{total}} ont déjà été analysé(s) contre cette offre (mais pas dans cette combinaison exacte).\n\nCette nouvelle combinaison permettra une classification comparative globale.\n\nÊtes-vous sûr de vouloir continuer avec cette analyse ?",
        exactCombinationMessage: "Cette combinaison exacte ({{count}} CVs) a déjà été analysée contre cette offre le {{date}} à {{time}}.\n\nÊtes-vous sûr de vouloir refaire cette analyse identique ?"
      },
      errors: {
        dataLoadFailed: "Erreur lors du chargement des données",
        cvsLoadFailed: "Erreur lors du chargement des CVs",
        selectOfferAndCvs: "Veuillez sélectionner une offre et au moins un CV",
        maxCvsAtOnce: "Vous ne pouvez analyser que 25 CVs maximum à la fois",
        reanalysisError: "Erreur lors de la re-analyse",
        analysisError: "Erreur lors de l'analyse",
        exportError: "Erreur lors de l'export",
        noOfferSelected: "Veuillez sélectionner une offre d'emploi",
        noCvsSelected: "Veuillez sélectionner au moins un CV",
        analysisLimitReached: "Limite d'analyses IA atteinte pour ce mois",
        upgradeRequired: "Mise à niveau requise"
      },
      warnings: {
        maxCvsLimit: "Vous pouvez sélectionner maximum 25 CVs pour une analyse"
      },
      messages: {
        limitedSelection: "Sélection limitée aux 25 premiers CVs ({{count}} CVs disponibles)",
        analysisComplete: "Analyse terminée ! {{count}} CVs analysés",
        analysisCancelled: "Analyse annulée",
        exportSuccess: "Résultats exportés avec succès",
        analysisStarted: "Analyse IA démarrée"
      }
    },

    // Results section
    results: {
      title: "Résultats d'Analyse",
      subtitle: "Consultez et exportez vos résultats d'analyse IA",
      noResults: "Aucun résultat d'analyse",
      runFirstAnalysis: "Effectuez votre première analyse IA pour voir les résultats",
      filters: {
        all: "Tous les résultats",
        recent: "Récents",
        byOffer: "Par offre",
        byScore: "Par score",
        searchPlaceholder: "Rechercher dans les résultats..."
      },
      sorting: {
        newest: "Plus récents",
        oldest: "Plus anciens",
        highestScore: "Score le plus élevé",
        lowestScore: "Score le plus bas",
        alphabetical: "Alphabétique"
      },
      actions: {
        view: "Voir les détails",
        export: "Exporter",
        delete: "Supprimer",
        compareAll: "Comparer tout",
        sendToKanban: "Envoyer vers Kanban",
        generateReport: "Générer rapport"
      },
      export: {
        title: "Exporter les résultats",
        format: "Format d'export",
        excel: "Excel (.xlsx)",
        csv: "CSV (.csv)",
        pdf: "PDF (.pdf)",
        includeDetails: "Inclure les détails d'analyse",
        includeScores: "Inclure les scores",
        includeRecommendations: "Inclure les recommandations",
        exporting: "Export en cours...",
        success: "Export réussi",
        error: "Erreur lors de l'export"
      },
      scoreRanges: {
        excellent: "Excellent (90-100%)",
        good: "Bon (70-89%)",
        average: "Moyen (50-69%)",
        poor: "Faible (0-49%)"
      },
      details: {
        title: "Détails de l'analyse",
        candidate: "Candidat",
        offer: "Offre d'emploi",
        overallScore: "Score global",
        analysisDate: "Date d'analyse",
        skillsMatch: "Correspondance des compétences",
        experienceMatch: "Correspondance de l'expérience",
        educationMatch: "Correspondance de la formation",
        strengths: "Points forts",
        weaknesses: "Points d'amélioration",
        recommendation: "Recommandation",
        aiAnalysis: "Analyse IA détaillée"
      },
      comparison: {
        title: "Comparaison des candidats",
        selectCandidates: "Sélectionner les candidats à comparer",
        compare: "Comparer",
        criteria: "Critères de comparaison",
        skills: "Compétences",
        experience: "Expérience",
        education: "Formation",
        overall: "Score global"
      },
      messages: {
        exported: "Résultats exportés avec succès",
        deleted: "Résultat supprimé avec succès",
        sentToKanban: "Candidat envoyé vers le Kanban"
      }
    },

    // Kanban page
    kanban: {
      title: "Tableau Kanban",
      subtitle: "Gérez vos candidats avec un tableau visuel interactif",
      actions: {
        newColumn: "Nouvelle colonne",
        column: "Colonne",
        addCandidate: "Ajouter un candidat",
        editColumn: "Modifier la colonne",
        deleteColumn: "Supprimer la colonne"
      },
      stats: {
        totalCandidates: "Total candidats",
        activeColumns: "Colonnes actives",
        visibleCandidates: "Candidats visibles"
      },
      exitFullscreen: "Quitter plein écran",
      enterFullscreen: "Plein écran",
      searchPlaceholder: "Rechercher un candidat...",
      filters: {
        allScores: "Tous les scores",
        above70: "Score ≥ 70",
        above80: "Score ≥ 80",
        above90: "Score ≥ 90"
      },
      candidates: "candidats",
      filtered: "filtrés",
      noCandidates: "Aucun candidat",
      noMatchingCandidates: "Aucun candidat correspondant",
      tryAdjustingFilters: "Essayez d'ajuster vos filtres",
      candidate: "Candidat",
      analyzed: "Analysé",
      columns: {
        received: "Reçues",
        screening: "Présélection",
        interview: "Entretien",
        selected: "Sélectionnés",
        hired: "Embauché"
      },
      candidateActions: {
        addNote: "Ajouter une note",
        viewProfile: "Voir le profil",
        downloadCV: "Télécharger CV",
        moveToColumn: "Déplacer vers",
        delete: "Supprimer"
      },
      noItems: "Aucun candidat dans cette colonne",
      dragHint: "Glissez-déposez les candidats entre les colonnes",
      errors: {
        loadingBoard: "Erreur lors du chargement",
        loadingBoardToast: "Erreur lors du chargement du tableau",
        movingCandidate: "Erreur lors du déplacement",
        movingCandidateToast: "Erreur lors du déplacement du candidat",
        removingCandidate: "Erreur lors du retrait",
        removingCandidateToast: "Erreur lors du retrait du candidat",
        deletingCandidateToast: "Erreur lors de la suppression du candidat",
        deletingColumn: "Erreur lors de la suppression",
        deletingColumnToast: "Erreur lors de la suppression de la colonne",
        columnHasCandidates: "Cette colonne contient {{count}} candidat(s). Veuillez les déplacer avant de supprimer la colonne."
      },
      messages: {
        candidateMoved: "Candidat déplacé avec succès",
        candidateRemoved: "Candidat retiré du kanban avec succès",
        columnDeleted: "Colonne supprimée avec succès",
        candidateDeleted: "Candidat supprimé avec succès"
      },
      tooltips: {
        addCandidate: "Ajouter un candidat",
        editColumn: "Modifier la colonne",
        deleteColumn: "Supprimer la colonne"
      },
      confirmations: {
        removeCandidate: {
          title: "Retirer le candidat",
          message: "Êtes-vous sûr de vouloir retirer ce candidat du kanban ?\n(La fiche candidat sera conservée dans les CVs)",
          confirm: "Retirer",
          cancel: "Annuler"
        },
        deleteCandidate: {
          title: "Supprimer le candidat",
          message: "Êtes-vous sûr de vouloir supprimer définitivement ce candidat ?",
          confirm: "Supprimer",
          cancel: "Annuler"
        },
        deleteColumn: {
          title: "Supprimer la colonne",
          message: "Êtes-vous sûr de vouloir supprimer cette colonne ? Cette action est irréversible.",
          confirm: "Supprimer",
          cancel: "Annuler"
        }
      },
      columnModal: {
        createTitle: "Créer une colonne",
        editTitle: "Modifier la colonne",
        nameLabel: "Nom de la colonne *",
        namePlaceholder: "Ex: En attente, En cours, Terminé...",
        colorLabel: "Couleur",
        previewLabel: "Aperçu",
        previewNamePlaceholder: "Nom de la colonne",
        previewDescription: "Les candidats seront affichés ici",
        cancel: "Annuler",
        create: "Créer",
        update: "Mettre à jour",
        saving: "Enregistrement...",
        saveError: "Erreur lors de la sauvegarde",
        createSuccess: "Colonne créée avec succès",
        updateSuccess: "Colonne mise à jour"
      }
    },



    // HR Management page
    hrManagement: {
      title: "Gestion RH",
      subtitle: "Gérez les comptes utilisateurs RH de votre équipe",
      noUsers: "Aucun utilisateur trouvé",
      createFirst: "Commencez par ajouter un utilisateur RH",
      searchPlaceholder: "Rechercher un utilisateur...",
      addUser: "Ajouter un utilisateur RH",
      
      // Dashboard stats
      stats: {
        hrUsers: "Utilisateurs RH",
        totalAnalyses: "Analyses totales", 
        createdOffers: "Offres créées",
        uploadedCvs: "CVs uploadés"
      },
      
      // License information
      license: {
        title: "Informations de licence",
        currentPackage: "Package actuel",
        status: "Statut",
        expiration: "Expiration",
        active: "Active",
        inactive: "Inactive",
        notDefined: "Non défini",
        notDefinedDate: "Non définie"
      },
      
      // Filters
      filters: {
        allStatuses: "Tous les statuts",
        verified: "Vérifiés",
        unverified: "Non vérifiés"
      },
      
      // Table headers
      table: {
        user: "Utilisateur",
        email: "Email",
        status: "Statut",
        createdDate: "Date de création",
        actions: "Actions"
      },
      
      // User status
      userStatus: {
        verified: "Vérifié",
        unverified: "Non vérifié",
        hrUser: "Utilisateur RH",
        nameNotDefined: "Nom non défini"
      },
      
      // Pagination
      pagination: {
        previous: "Précédent",
        next: "Suivant",
        showing: "Affichage de",
        to: "à",
        of: "sur",
        results: "résultats"
      },
      
      // Search and filters help text
      searchHelp: {
        modifySearch: "Essayez de modifier vos critères de recherche"
      },
      
      // Modals
      modals: {
        add: {
          title: "Ajouter un utilisateur RH",
          fullName: "Nom complet",
          emailAddress: "Adresse email",
          password: "Mot de passe",
          namePlaceholder: "Nom de l'utilisateur",
          emailPlaceholder: "email@exemple.com",
          passwordPlaceholder: "Mot de passe (min. 8 caractères)",
          verificationNote: "Un email de vérification sera envoyé à l'utilisateur",
          cancel: "Annuler",
          create: "Créer l'utilisateur",
          creating: "Création..."
        },
        edit: {
          title: "Modifier l'utilisateur",
          fullName: "Nom complet",
          emailAddress: "Adresse email",
          newPassword: "Nouveau mot de passe (optionnel)",
          emailNote: "Changer l'email réinitialisera la vérification",
          passwordPlaceholder: "Laisser vide pour ne pas modifier",
          cancel: "Annuler",
          update: "Mettre à jour",
          updating: "Mise à jour..."
        },
        delete: {
          title: "Supprimer l'utilisateur",
          confirmText: "Êtes-vous sûr de vouloir supprimer l'utilisateur",
          warningText: "Cette action est irréversible. L'utilisateur ne pourra plus accéder à son compte.",
          cancel: "Annuler",
          delete: "Supprimer",
          deleting: "Suppression..."
        }
      },
      
      // Action tooltips
      tooltips: {
        resendVerification: "Renvoyer l'email de vérification",
        edit: "Modifier",
        delete: "Supprimer"
      },
      
      // Toast messages
      messages: {
        loadError: "Erreur lors du chargement des données",
        fillAllFields: "Veuillez remplir tous les champs",
        fillNameEmail: "Veuillez remplir le nom et l'email",
        passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
        userCreated: "Utilisateur RH créé avec succès",
        createError: "Erreur lors de la création de l'utilisateur",
        userUpdated: "Utilisateur mis à jour avec succès",
        updateError: "Erreur lors de la mise à jour",
        userDeleted: "Utilisateur supprimé avec succès",
        deleteError: "Erreur lors de la suppression",
        alreadyVerified: "L'utilisateur est déjà vérifié",
        verificationSent: "Email de vérification envoyé à",
        emailError: "Erreur lors de l'envoi de l'email"
      }
    },

    // Subscription page
    subscription: {
      title: "Mon Abonnement",
      subtitle: "Gérez votre abonnement et consultez votre utilisation",
      currentPlan: "Plan Actuel",
      usage: "Utilisation",
      billing: "Facturation",
      upgrade: "Mettre à niveau",
      downgrade: "Rétrograder",
      cancel: "Annuler l'abonnement",
      renew: "Renouveler",
      changePaymentMethod: "Modifier le mode de paiement",
      billingHistory: "Historique de facturation",
      nextBilling: "Prochaine facturation",
      autoRenewal: "Renouvellement automatique",
      
      // Subscription details
      subscriptionDetails: "Détails de l'Abonnement",
      startDate: "Date de début",
      endDate: "Fin d'accès",
      autoRenewalActive: "⚡ Renouvellement automatique actif",
      changePlan: "Changer de plan",
      exploreOtherPlans: "Explorez nos autres plans pour bénéficier de plus de fonctionnalités",
      perMonth: "/mois",
      
      // Status
      status: {
        active: "Actif",
        cancelled: "Annulé",
        expired: "Expiré"
      },
      
      // Auto renewal section
      autoRenewalTitle: "Renouvellement Automatique Actif",
      autoRenewalDescription: "Votre abonnement se renouvellera automatiquement le {{date}} pour {{price}}. Les compteurs d'usage seront réinitialisés à cette date.",
      
      // Cancelled renewal section
      cancelledRenewalTitle: "Renouvellement Automatique Annulé",
      cancelledRenewalDescription: "Votre abonnement ne se renouvellera pas automatiquement. Vous conservez l'accès jusqu'au {{date}}. Vous pouvez réactiver le renouvellement automatique à tout moment.",
      
      // Actions
      cancelAutoRenewal: "Annuler renouvellement automatique",
      activateAutoRenewal: "Activer renouvellement automatique",
      
      // Usage section
      refreshUsageData: "Actualiser les données d'usage",
      used: "utilisé",
      limitAlmostReached: "Limite presque atteinte",
      noDataAvailable: "Aucune donnée disponible",
      usageStatsWillAppear: "Les statistiques d'utilisation apparaîtront ici",
      
      // Plan change options
      otherPlansAvailable: "Autres Plans Disponibles",
      discoverPlansEvolution: "Découvrez nos plans pour évoluer selon vos besoins",
      upgradeAction: "⬆️ UPGRADE",
      economical: "⬇️ ÉCONOMIQUE",
      
      // Plan names
      planNames: {
        demo: "Démo Gratuit",
        essential: "Essentiel RH",
        enterprise: "Entreprise"
      },
      
      // Plan descriptions
      planDescriptions: {
        demo: "Découvrez notre solution",
        essential: "Pour équipes RH en croissance",
        enterprise: "Solution enterprise complète"
      },
      
      // Features
      unlimitedAnalyses: "Analyses illimitées",
      analysesPerMonth: "analyses/mois",
      hrUser: "utilisateur RH",
      hrUsers: "utilisateurs RH",
      jobOffers: "offres d'emploi",
      cvsPerMonth: "CVs/mois",
      cvUploads: "CVs uploadés",
      aiAnalysesPerMonth: "analyses IA/mois",
      aiResumesPerMonth: "résumés IA/mois",
      appointments: "Rendez-vous",
      customMinioStorage: "Stockage MinIO personnalisé",
      videoAutomation: "Automatisation URL meeting",
      
      // Plan change actions
      upgradeToNext: "Passer au niveau supérieur",
      choosePlan: "Choisir ce plan",
      selectPlan: "Sélectionner",
      validating: "Validation...",
      
      // Plan change information
      planChangeTerms: "Modalités de changement de plan",
      upgradesInfo: "<strong>Améliorations :</strong> Appliquées immédiatement avec calcul au prorata",
      downgradesInfo: "<strong>Rétrogradations :</strong> Prennent effet à la fin de la période actuelle",
      countersInfo: "<strong>Compteurs :</strong> Réinitialisés lors des changements de plan",
      
      // Usage statistics labels
      usageLabels: {
        used: "utilisé(s)",
        allowed: "autorisé(s)",
        excess: "en excès"
      },
      
      // Error messages
      errors: {
        loadingSubscription: "Erreur lors du chargement de l'abonnement",
        planChangeValidation: "Erreur lors de la validation du changement de plan",
        cancellation: "Erreur lors de l'annulation",
        reactivation: "Erreur lors de la réactivation",
        downgradeImpossible: "Rétrogradation impossible",
        currentUsageExceeds: "Votre utilisation actuelle dépasse les limites du plan sélectionné:\n\n{{conflicts}}\n\nVeuillez d'abord supprimer les éléments en excès avant de procéder à la rétrogradation.",
        understood: "Compris"
      },
      
      // Success messages
      success: {
        autoRenewalCancelled: "Renouvellement automatique annulé avec succès",
        autoRenewalActivated: "Renouvellement automatique activé avec succès"
      },
      
      // Confirmation modal
      confirmModal: {
        cancelAutoRenewalTitle: "Annuler le renouvellement automatique",
        cancelAutoRenewalMessage: "Êtes-vous sûr de vouloir annuler le renouvellement automatique de votre abonnement ?\n\n• Aucune facturation automatique future\n• Accès maintenu jusqu'au {{date}}\n• Possibilité de réactiver le renouvellement à tout moment",
        cancelRenewal: "Annuler le renouvellement",
        keepRenewal: "Garder le renouvellement"
      },
      
      // Currency display
      pricesShownIn: "Prix affichés en"
    },

    // Applications page
    applications: {
      title: "Candidatures",
      subtitle: "Gérez les candidatures reçues via vos offres publiées",
      noApplications: "Aucune candidature reçue",
      
      // Published offers section
      publishedOffers: {
        title: "Offres et candidatures",
        noOffers: "Aucune offre publiée ou avec candidatures",
        noOffersHint: "Publiez une offre pour recevoir des candidatures",
        copyUrl: "Copier l'URL",
        urlCopied: "URL copiée dans le presse-papier",
        applicationCount: "candidature",
        applicationCountPlural: "candidatures",
        viewCount: "vue",
        viewCountPlural: "vues",
        newApplications: "nouveau",
        newApplicationsPlural: "nouveaux",
        shortlistedApplications: "présélectionné",
        shortlistedApplicationsPlural: "présélectionnés",
        unpublished: "Dépubliée"
      },
      
      // Applications list section
      applicationsReceived: "Candidatures reçues",
      selectOffer: "Sélectionnez une offre",
      selectOfferPrompt: "Sélectionnez une offre publiée pour voir les candidatures",
      noApplicationsForOffer: "Aucune candidature pour cette offre",
      noApplicationsHint: "Les nouvelles candidatures apparaîtront ici",
      
      // Filters and search
      filters: {
        all: "Toutes",
        allStatuses: "Tous les statuts",
        new: "Nouveaux",
        reviewed: "Examinés",
        shortlisted: "Présélectionnés",
        rejected: "Rejetés",
        searchPlaceholder: "Rechercher..."
      },
      
      // Status badges
      status: {
        new: "Nouveau",
        reviewed: "Examiné",
        shortlisted: "Présélectionné",
        rejected: "Rejeté"
      },
      
      // Actions
      actions: {
        viewDetails: "Voir les détails",
        previewCV: "Aperçu du CV",
        delete: "Supprimer la candidature",
        sendAppointment: "Envoyer une invitation de rendez-vous",
        markAsReviewed: "Marquer comme examiné",
        shortlist: "Présélectionner",
        reject: "Rejeter",
        manageCV: "Gérer le CV",
        addToKanban: "Ajouter au Kanban",
        alreadyInKanban: "Déjà dans le Kanban"
      },
      
      // Application modal
      modal: {
        candidateInfo: "Informations du candidat",
        currentStatus: "Statut actuel",
        candidateMessage: "Message du candidat",
        internalNotes: "Notes internes",
        addNote: "Ajouter une note interne sur ce candidat...",
        addNoteButton: "Ajouter une note",
        noNotes: "Aucune note interne pour cette candidature",
        noNotesHint: "Ajoutez la première note pour documenter vos échanges",
        modified: "(modifié)",
        edit: "Modifier",
        save: "Enregistrer",
        loadMoreNotes: "Voir plus de notes ({{count}} restantes)",
        appliedOn: "Candidature envoyée le {{date}}",
        source: "Source: {{source}}"
      },
      
      // CV Preview modal
      cvPreview: {
        title: "Aperçu du CV",
        docxFile: "Fichier DOCX",
        docxNotSupported: "L'aperçu direct des fichiers DOCX n'est pas encore disponible.",
        extractedContent: "Contenu extrait :",
        textNotExtracted: "Le texte n'a pas encore été extrait de ce fichier.",
        downloadFile: "Télécharger le fichier",
        oldDocFormat: "Fichier DOC (ancien format)",
        oldDocNotSupported: "L'aperçu des fichiers .DOC n'est pas supporté.\nVeuillez télécharger le fichier pour le voir.",
        unsupportedFormat: "Format non supporté",
        unsupportedMessage: "Ce type de fichier ne peut pas être prévisualisé.",
        browserNotSupported: "Votre navigateur ne supporte pas l'affichage des PDFs.",
        clickToDownload: "Cliquez ici pour télécharger le fichier.",
        fileLabel: "Fichier :",
        sizeLabel: "Taille :",
        download: "Télécharger",
        loadError: "Erreur lors du chargement du PDF"
      },
      
      // Pagination
      pagination: {
        showing: "Affichage de {{start}} à {{end}} sur {{total}} candidatures"
      },
      
      // Confirmation dialogs
      confirmations: {
        deleteTitle: "Supprimer la candidature",
        deleteMessage: "Êtes-vous sûr de vouloir supprimer la candidature de {{name}} ?\n\nCette action est irréversible et supprimera également le CV associé.",
        deleteButton: "Supprimer",
        cancelButton: "Annuler"
      },
      
      // Delete application modal
      deleteApplicationModal: {
        title: "Supprimer la candidature",
        message: "Vous êtes sur le point de supprimer la candidature de {{name}}.",
        activeAppointmentsNotice: "Ce candidat a des rendez-vous en cours ou en attente. Le CV sera automatiquement conservé dans la section Upload.",
        keepCvOption: "Supprimer la candidature uniquement",
        keepCvDescription: "Le CV sera conservé et restera accessible dans la section Upload",
        deleteAllOption: "Supprimer la candidature et le CV",
        deleteAllDescription: "Suppression définitive de la candidature et du CV associé",
        confirm: "Confirmer"
      },
      
      // Messages and errors
      messages: {
        dataLoadError: "Erreur lors du chargement des données",
        applicationLoadError: "Erreur lors du chargement de la candidature",
        statusUpdated: "Statut mis à jour avec succès",
        statusUpdateError: "Erreur lors de la mise à jour du statut",
        applicationDeleted: "Candidature supprimée avec succès",
        applicationDeletedCvKept: "Candidature supprimée avec succès. Le CV a été conservé dans la section Upload",
        deleteError: "Erreur lors de la suppression",
        noCVAssociated: "Aucun CV associé à cette candidature",
        cvLoadError: "Erreur lors du chargement du CV",
        noteLoadError: "Erreur lors du chargement des notes",
        noteAdded: "Note ajoutée avec succès",
        noteAddError: "Erreur lors de l'ajout de la note",
        noteUpdated: "Note mise à jour avec succès",
        noteUpdateError: "Erreur lors de la mise à jour de la note",
        noteDeleted: "Note supprimée avec succès",
        noteDeleteError: "Erreur lors de la suppression de la note",
        addedToKanban: "Candidat ajouté au Kanban avec succès",
        alreadyInKanban: "Ce candidat est déjà dans le Kanban",
        addToKanbanError: "Impossible d'ajouter le candidat au Kanban",
        aiConfigMissing: "La configuration IA n'est pas définie. Ajoutez vos clés API dans Paramètres > Développeur > Fournisseurs IA.",
        aiInvalidToken: "Clé API IA invalide. Vérifiez votre token dans Paramètres > Développeur > Fournisseurs IA."
      },
      
      // Legacy compatibility
      candidate: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        appliedDate: "Date de candidature",
        position: "Poste"
      }
    }
  },

  // Notes page
  notes: {
    title: "Gestion des Notes",
    subtitle: "Créez, organisez et partagez vos notes avec votre équipe",
    actions: {
      createNote: "Nouvelle note",
      editNote: "Modifier la note",
      deleteNote: "Supprimer la note",
      shareNote: "Partager la note"
    },
    createNote: "Créer une note",
    editNote: "Modifier la note",
    deleteNote: "Supprimer la note",
    noteTitle: "Titre de la note",
    noteContent: "Contenu",
    candidate: "Candidat",
    offer: "Offre d'emploi",
    tags: "Tags",
    priority: "Priorité",
    high: "Haute",
    medium: "Moyenne",
    low: "Basse",
    stats: {
      myNotes: "Mes notes",
      sharedNotes: "Notes partagées",
      total: "Total"
    },
    search: {
      placeholder: "Rechercher dans les notes..."
    },
    filters: {
      all: "Toutes les notes",
      own: "Mes notes",
      shared: "Notes partagées",
      byCandidate: "Par candidat",
      byOffer: "Par offre",
      byPriority: "Par priorité"
    },
    results: {
      count: "{{count}} note trouvée",
      countPlural: "{{count}} notes trouvées",
      found: "trouvée",
      foundPlural: "trouvées"
    },
    empty: {
      noNotesFound: "Aucune note trouvée",
      noNotesYet: "Aucune note pour le moment",
      tryModifyingSearch: "Essayez de modifier vos critères de recherche",
      createFirstNote: "Créez votre première note pour commencer",
      createNote: "Créer une note"
    },
    card: {
      shared: "Partagé",
      sharedBy: "par {{name}}",
      tooltips: {
        share: "Partager",
        edit: "Modifier",
        delete: "Supprimer"
      }
    },
    messages: {
      loadError: "Erreur lors du chargement des notes",
      deleteSuccess: "Note supprimée avec succès",
      deleteError: "Erreur lors de la suppression",
      deleteErrorGeneral: "Erreur lors de la suppression de la note",
      shareSuccess: "Note partagée avec succès",
      shareError: "Erreur lors du partage de la note",
      unshareSuccess: "Partage de la note arrêté",
      unshareError: "Erreur lors de l'arrêt du partage",
      selectUsers: "Sélectionnez au moins un utilisateur"
    },
    delete: {
      title: "Supprimer la note",
      message: "Êtes-vous sûr de vouloir supprimer cette note ?\n\nCette action est irréversible.",
      confirmText: "Supprimer",
      cancelText: "Annuler"
    },
    modal: {
      createTitle: "Créer une nouvelle note",
      editTitle: "Modifier la note",
      titleLabel: "Titre de la note *",
      titlePlaceholder: "Entrez le titre de la note",
      contentLabel: "Contenu *",
      contentPlaceholder: "Décrivez votre note en détail...",
      tagsLabel: "Étiquettes",
      tagsPlaceholder: "Tapez et appuyez sur Entrée pour ajouter des étiquettes",
      tagsHelp: "Utilisez des étiquettes pour organiser vos notes",
      charactersLabel: "caractères",
      cancelButton: "Annuler",
      createButton: "Créer la note",
      updateButton: "Mettre à jour la note",
      savingLabel: "Enregistrement en cours...",
      errors: {
        titleRequired: "Le titre est requis",
        titleTooLong: "Le titre ne peut pas dépasser 200 caractères",
        contentRequired: "Le contenu est requis",
        contentTooLong: "Le contenu ne peut pas dépasser 5000 caractères",
        tagsTooLong: "Les étiquettes ne peuvent pas dépasser 500 caractères",
        saveError: "Erreur lors de la sauvegarde de la note",
        saveErrorGeneral: "Une erreur s'est produite lors de la sauvegarde"
      },
      messages: {
        createSuccess: "Note créée avec succès",
        updateSuccess: "Note mise à jour avec succès"
      }
    },
    shareModal: {
      title: "Partager la note",
      searchPlaceholder: "Rechercher un membre de l'équipe...",
      currentlyShared: "Actuellement partagé avec :",
      teamMembers: "Membres de l'équipe",
      noMembersFound: "Aucun membre trouvé avec cette recherche",
      noMembers: "Aucun membre dans votre équipe",
      selected: "sélectionné",
      selectedPlural: "sélectionnés",
      share: "Partager",
      stopSharing: "Arrêter le partage",
      cancel: "Annuler",
      sharing: "Partage...",
      shared: "Partagé",
      stopSharingConfirm: {
        title: "Arrêter le partage",
        message: "Êtes-vous sûr de vouloir arrêter le partage de cette note ? Tous les utilisateurs perdront l'accès.",
        confirmText: "Arrêter le partage",
        cancelText: "Annuler"
      }
    },
    noNotes: "Aucune note créée",
    createFirst: "Créez votre première note"
  },

  // Offers section
  offers: {
    title: "Gestion des Offres",
    subtitle: {
      admin: "Gérez les offres de votre équipe",
      hr: "Offres partagées avec votre équipe"
    },
    noOffers: "Aucune offre d'emploi créée",
    createFirst: "Créez votre première offre d'emploi pour commencer",
    actions: {
      createNew: "Nouvelle offre",
      create: "Créer une offre",
      view: "Voir les détails",
      edit: "Modifier",
      delete: "Supprimer",
      duplicate: "Dupliquer",
      archive: "Archiver",
      publish: "Publier l'offre",
      unpublish: "Retirer de la publication",
      copyUrl: "Copier l'URL",
      menu: "Menu des actions"
    },
    status: {
      open: "Ouverte",
      closed: "Fermée",
      cancelled: "Annulée",
      draft: "Brouillon",
      archived: "Archivée"
    },
    fields: {
      title: "Titre du poste",
      client: "Client",
      location: "Localisation",
      type: "Type de contrat",
      experience: "Expérience requise",
      skills: "Compétences requises",
      salary: "Salaire",
      description: "Description",
      requirements: "Exigences",
      benefits: "Avantages",
      deadline: "Date limite",
      createdAt: "Créée le",
      updatedAt: "Mise à jour le"
    },
    labels: {
      published: "Publié",
      team: "Équipe",
      requiredSkills: "Compétences requises",
      createdOn: "Créée le",
      modifiedOn: "Modifiée le",
      publishedOn: "Publiée le",
      view: "vue"
    },
    stats: {
      total: "Total",
      open: "Ouvertes",
      closed: "Fermées",
      cancelled: "Annulées"
    },
    search: {
      placeholder: "Rechercher par titre, client, ou compétences..."
    },
    filters: {
      title: "Filtres",
      search: "Recherche",
      status: "Statut",
      active: "Filtres actifs",
      clearAll: "Tout réinitialiser",
      allStatuses: "Tous les statuts",
      open: "Ouvertes",
      closed: "Fermées",
      cancelled: "Annulées"
    },
    emptyState: {
      title: "Aucune offre trouvée",
      filterHint: "Essayez de modifier vos filtres de recherche.",
      createHint: "Commencez par créer votre première offre d'emploi."
    },
    deleteModal: {
      title: "Supprimer l'offre",
      message: "Êtes-vous sûr de vouloir supprimer cette offre ?\n\nCette action supprimera également tous les résultats d'analyse associés.",
      confirm: "Supprimer",
      cancel: "Annuler"
    },
    unpublishModal: {
      title: "Retirer de la publication",
      message: "Êtes-vous sûr de vouloir retirer cette offre de la publication ?\n\nLe lien public ne sera plus accessible aux candidats.",
      confirm: "Retirer",
      cancel: "Annuler"
    },
    errors: {
      loadFailed: "Erreur lors du chargement des offres",
      deleteFailed: "Erreur lors de la suppression",
      hasDependencies: "Ce CV ne peut pas être supprimé car il est lié à d'autres éléments.",
      notFound: "CV introuvable",
      publishFailed: "Erreur lors de la publication",
      unpublishFailed: "Erreur lors de la dépublication",
      createFailed: "Erreur lors de la création",
      updateFailed: "Erreur lors de la modification",
      usageLimitReached: "Limite d'usage atteinte"
    },
    messages: {
      createSuccess: "Offre créée avec succès",
      updateSuccess: "Offre modifiée avec succès",
      deleteSuccess: "Offre supprimée avec succès",
      publishSuccess: "Offre publiée avec succès !",
      unpublishSuccess: "Offre retirée de la publication",
      urlCopied: "URL copiée dans le presse-papier"
    },
    modal: {
      createTitle: "Nouvelle offre",
      editTitle: "Modifier l'offre",
      subtitle: "Remplissez les informations pour créer une offre d'emploi attractive",
      steps: {
        basic: "Informations de base",
        details: "Détails du poste",
        description: "Description"
      },
      step1: {
        title: "Informations de base"
      },
      step2: {
        title: "Compétences et exigences"
      },
      step3: {
        title: "Description du poste"
      }
    },
    form: {
      title: "Titre de l'offre",
      titlePlaceholder: "Ex: Développeur React Senior",
      titleHint: "Un titre clair et précis attire plus de candidats",
      client: "Client",
      clientPlaceholder: "Ex: TechCorp",
      location: "Localisation",
      locationPlaceholder: "Ex: Paris, Remote",
      duration: "Durée",
      durationPlaceholder: "Ex: 6 mois, CDI",
      status: "Statut",
      statusOpen: "Ouverte",
      statusClosed: "Fermée",
      statusCancelled: "Annulée",
      requiredSkills: "Compétences requises",
      skillsPlaceholder: "Tapez une compétence et appuyez sur Entrée",
      skillsHint: "Tapez une compétence et appuyez sur Entrée ou virgule pour l'ajouter",
      addSkill: "Ajouter",
      description: "Description complète",
      descriptionPlaceholder: "Décrivez le poste, les responsabilités, l'environnement de travail...",
      descriptionHint: "Une description détaillée aide les candidats à mieux comprendre le poste",
      preview: "Aperçu de l'offre",
      previous: "Précédent",
      next: "Suivant",
      cancel: "Annuler",
      create: "Créer",
      update: "Modifier",
      creating: "Création...",
      updating: "Modification..."
    },
    validation: {
      titleRequired: "Le titre est requis",
      skillsRequired: "Au moins une compétence est requise",
      descriptionRequired: "La description est requise"
    }
  },

  // CVs section
  cvs: {
    title: "Gestion des CVs",
    subtitle: {
      admin: "CVs partagés avec votre équipe RH",
      hr: "CVs accessibles à toute votre équipe"
    },
    noCvs: "Aucun CV téléchargé",
    uploadFirst: "Téléchargez votre premier CV pour commencer l'analyse",
    upload: {
      title: "Télécharger des CVs",
      dragDrop: "Glissez-déposez vos fichiers ici",
      or: "ou",
      clickToSelect: "Cliquez pour sélectionner",
      orDragDrop: "ou glissez-déposez vos fichiers ici",
      pdfOnly: "Fichiers PDF ou DOCX, jusqu'à 10MB par fichier",
      supportedFormats: "Formats supportés : PDF, DOCX",
      maxSize: "Taille maximum : 10 MB par fichier",
      maxFiles: "Maximum 10 fichiers à la fois",
      maxFilesLimit: "Maximum 50 fichiers par upload",
      uploading: "Téléchargement en cours...",
      processing: "Traitement des fichiers...",
      clickToSelectFiles: "Cliquez pour sélectionner vos fichiers",
      selectedFiles: "Fichiers sélectionnés",
      clearSelection: "Tout supprimer",
      startExtraction: "Uploader + Extraire le texte",
      processingExtraction: "Upload + Extraction...",
      success: "CV téléchargés avec succès",
      error: "Erreur lors du téléchargement"
    },
    sections: {
      byOffer: "CVs par Offre Publiée",
      manual: "CVs Uploadés Manuellement",
      searchResults: "Résultats de recherche",
      all: "Tous les CVs",
      applications: "CVs de Candidatures",
      applicationsUnlinked: "CVs de Candidatures (Sans Offre)",
      manualFull: "CVs Uploadés Manuellement"
    },
    tabs: {
      offers: "Banque CVs publiés par offres",
      manual: "Banque CVs uploadés manuellement"
    },
    filters: {
      title: "Filtres",
      search: "Recherche",
      type: "Type",
      origin: "Origine",
      offer: "Offre",
      active: "Filtres actifs",
      clearAll: "Tout réinitialiser",
      all: "Tous les CV",
      recent: "Récents",
      analyzed: "Analysés",
      notAnalyzed: "Non analysés",
      searchPlaceholder: "Rechercher par nom de candidat...",
      allTypes: "Tous les types",
      allOrigins: "Toutes les origines",
      allOffers: "Toutes les offres",
      manualUpload: "Upload manuel",
      application: "Candidature"
    },
    actions: {
      view: "Voir le CV",
      download: "Télécharger",
      delete: "Supprimer",
      analyze: "Analyser",
      generateProfile: "Générer profil candidat",
      addToKanban: "Ajouter au Kanban",
      removeFromKanban: "Retirer du Kanban",
      upload: "Uploader des CVs",
      preview: "Prévisualiser le CV",
      aiResume: "Résumé AI + création fiche candidat",
      sendAppointment: "Envoyer une invitation de rendez-vous",
      editCandidate: "Voir/Modifier la fiche"
    },
    fields: {
      candidate: "Candidat",
      filename: "Nom du fichier",
      uploadDate: "Date de téléchargement",
      fileSize: "Taille",
      status: "Statut",
      lastAnalysis: "Dernière analyse",
      score: "Score"
    },
    status: {
      uploaded: "Téléchargé",
      processing: "En traitement",
      analyzed: "Analysé",
      error: "Erreur"
    },
    candidateProfile: {
      title: "Profil Candidat",
      generateWith: "Générer avec l'IA",
      generating: "Génération en cours...",
      generated: "Profil généré avec succès",
      summary: "Résumé professionnel",
      experience: "Expérience",
      skills: "Compétences",
      education: "Formation",
      languages: "Langues",
      contact: "Contact"
    },
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce CV ?",
    labels: {
      team: "Équipe",
      selectedFromApplication: "CV sélectionné depuis la candidature",
      receivedViaApplication: "CV reçu via candidature publique",
      receivedFromApplications: "CVs reçus via candidatures publiques",
      uploadedByTeam: "CVs uploadés par votre équipe",
      offer: "Offre",
      application: "Candidature",
      manual: "Manuel",
      candidateCardCreated: "Fiche créée",
      sharedToKanban: "Partagé au kanban"
    },
    stats: {
      total: "Total",
      documents: "PDF/DOCX",
      manual: "Upload manuel",
      applications: "Candidatures"
    },
    search: {
      placeholder: "Rechercher par nom de fichier..."
    },
    viewMode: {
      label: "Mode d'affichage",
      sections: "Sections",
      grouped: "Par Offre",
      list: "Liste",
      expandAll: "Tout déplier",
      collapseAll: "Tout replier"
    },
    emptyState: {
      title: "Aucun CV trouvé",
      filterHint: "Essayez de modifier vos filtres de recherche.",
      uploadHint: "Commencez par uploader vos premiers CVs."
    },
    deleteModal: {
      title: "Supprimer le CV",
      message: "Êtes-vous sûr de vouloir supprimer le CV \"{{filename}}\" ?\n\nCette action est irréversible.",
      confirm: "Supprimer",
      cancel: "Annuler",
      warnings: {
        hasKanbanCard: "⚠️ Cette fiche candidat est partagée dans le kanban. La suppression du CV entraînera également la suppression de la fiche candidat et l'arrêt de son suivi dans le kanban.",
        hasAppointments: "⚠️ Le candidat de ce CV a des rendez-vous en cours. Êtes-vous sûr de vouloir supprimer son CV ?"
      }
    },
    candidateDeleteModal: {
      title: "Supprimer la fiche candidat",
      message: "Êtes-vous sûr de vouloir supprimer cette fiche candidat ?\n\nToutes les données associées seront perdues définitivement.",
      confirm: "Supprimer la fiche",
      cancel: "Annuler"
    },
    errors: {
      loadFailed: "Erreur lors du chargement des CVs",
      uploadFailed: "Erreur lors de l'upload",
      uploadFailedAll: "Impossible d'uploader les fichiers",
      deleteFailed: "Erreur lors de la suppression",
      downloadFailed: "Erreur lors du téléchargement du CV",
      analysisFailed: "Erreur lors de l'analyse",
      shareFailed: "Erreur lors du partage",
      unshareFailed: "Erreur lors du retrait",
      invalidFileType: "⚠️ Seuls les fichiers PDF ou DOCX sont acceptés. Veuillez convertir vos documents avant de les uploader.",
      fileTooLarge: "Fichier trop volumineux. Taille maximale : 10MB.",
      tooManyFiles: "Trop de fichiers sélectionnés. Réduisez le nombre de fichiers.",
      noValidFiles: "Aucun fichier PDF/DOCX valide détecté",
      noValidSelected: "Aucun fichier PDF/DOCX valide sélectionné",
      previewUnsupported: "Prévisualisation disponible uniquement pour les PDF. Téléchargez le fichier pour le consulter."
    },
    warnings: {
      extractTextFirst: "Veuillez d'abord extraire le texte du CV"
    },
    messages: {
      uploadSuccess: "{{count}} CV(s) uploadé(s) avec succès",
      duplicateFile: "Document \"{{filename}}\" existe déjà. Si c'est une mise à jour, veuillez supprimer l'ancien document ou changer son nom.",
      noNewFiles: "Aucun nouveau CV n'a été ajouté - tous les fichiers existaient déjà.",
      deleteSuccess: "CV supprimé avec succès",
      candidateCreated: "Fiche candidat créée avec succès",
      candidateDeleted: "Fiche candidat supprimée avec succès",
      sharedToKanban: "Candidat partagé au kanban avec succès",
      unsharedFromKanban: "Candidat retiré du kanban avec succès",
      uploaded: "CV téléchargé avec succès",
      deleted: "CV supprimé avec succès",
      profileGenerated: "Profil candidat généré avec succès"
    }
  },

  // Security & Privacy Page
  security: {
    title: "Sécurité et Confidentialité",
    subtitle: "Vos données en sécurité",
    
    tabs: {
      dataHosting: {
        label: "Hébergement des Données",
        description: "Où vos données sont stockées"
      },
      gdpr: {
        label: "RGPD et Conformité",
        description: "Conformité réglementaire"
      },
      dataUsage: {
        label: "Utilisation des Données",
        description: "Comment nous utilisons vos données"
      },
      userControl: {
        label: "Contrôle Utilisateur",
        description: "Gestion de vos données"
      },
      aiSecurity: {
        label: "IA et Sécurité",
        description: "Protection lors de l'analyse IA"
      }
    },
    
    features: {
      encryption: {
        title: "Chiffrement de bout en bout",
        description: "Toutes vos données sont chiffrées avec AES-256"
      },
      gdprCompliance: {
        title: "Conformité RGPD",
        description: "Conformité totale avec les réglementations européennes"
      },
      secureHosting: {
        title: "Hébergement sécurisé",
        description: "Données hébergées dans l'Union Européenne"
      },
      rightToForget: {
        title: "Droit à l'oubli",
        description: "Suppression complète de vos données à tout moment"
      }
    },
    
    hero: {
      badge: "Sécurité et Confidentialité",
      title: "Vos données en sécurité",
      subtitle: "Découvrez comment nous protégeons vos données personnelles et respectons votre vie privée avec les plus hauts standards de sécurité."
    },
    
    overview: {
      title: "Sécurité de niveau entreprise",
      subtitle: "Candio implémente les meilleures pratiques de sécurité pour protéger vos données sensibles et respecter votre confidentialité."
    },
    
    detailedInfo: {
      title: "Informations détaillées",
      subtitle: "Explorez en détail comment nous gérons, protégeons et respectons vos données personnelles."
    },
    
    dataHosting: {
      serverLocation: {
        title: "Localisation des serveurs",
        description: "Toutes vos données sont hébergées exclusivement dans des centres de données situés en <strong>Union Européenne</strong>, garantissant le respect des lois européennes sur la protection des données."
      },
      infrastructure: {
        title: "Infrastructure",
        items: [
          "Centres de données certifiés ISO 27001",
          "Redondance géographique multiple",
          "Sauvegardes automatiques quotidiennes",
          "Surveillance 24/7 des systèmes"
        ]
      },
      encryption: {
        title: "Chiffrement",
        items: [
          "Chiffrement AES-256 au repos",
          "TLS 1.3 pour les transmissions",
          "Clés de chiffrement rotatives",
          "Accès sécurisé par authentification double"
        ]
      }
    },
    
    gdpr: {
      compliance: {
        title: "Conformité RGPD totale",
        description: "Candio est entièrement conforme au Règlement Général sur la Protection des Données (RGPD) et respecte tous vos droits en tant qu'utilisateur."
      },
      rights: {
        title: "Vos droits RGPD",
        access: {
          title: "Droit d'accès",
          description: "Consulter toutes vos données personnelles"
        },
        rectification: {
          title: "Droit de rectification",
          description: "Corriger vos informations personnelles"
        },
        erasure: {
          title: "Droit à l'oubli",
          description: "Supprimer définitivement vos données"
        },
        portability: {
          title: "Droit de portabilité",
          description: "Exporter vos données dans un format standard"
        },
        objection: {
          title: "Droit d'opposition",
          description: "Vous opposer au traitement de vos données"
        },
        restriction: {
          title: "Droit de limitation",
          description: "Limiter le traitement de vos données"
        }
      },
      processingTimes: {
        title: "Délais de traitement",
        acknowledgment: "Accusé de réception",
        standard: "Traitement standard",
        maximum: "Délai légal maximum",
        hours24: "24h",
        days7: "7 jours",
        days30: "30 jours"
      }
    },
    
    dataUsage: {
      exclusive: {
        title: "Utilisation exclusive et transparente",
        description: "Vos données ne sont <strong>jamais vendues, partagées ou utilisées à d'autres fins</strong> que celles strictement nécessaires au fonctionnement de Candio."
      },
      whatWeDo: {
        title: "Ce que nous faisons avec vos données",
        analysis: {
          title: "Analyse et comparaison de CVs",
          description: "Traitement IA pour classifier et analyser les candidatures"
        },
        management: {
          title: "Gestion de votre compte",
          description: "Authentification, facturation et support client"
        },
        improvement: {
          title: "Amélioration du service",
          description: "Statistiques anonymisées pour optimiser nos algorithmes"
        }
      },
      whatWeDont: {
        title: "Ce que nous ne faisons JAMAIS",
        dataSale: {
          title: "Vente de données",
          description: "Vos données ne sont jamais vendues à des tiers"
        },
        commercialSharing: {
          title: "Partage commercial",
          description: "Aucun partage avec des partenaires commerciaux"
        },
        advertising: {
          title: "Utilisation publicitaire",
          description: "Pas de profilage pour la publicité ciblée"
        }
      }
    },
    
    userControl: {
      fullControl: {
        title: "Contrôle total de vos données",
        description: "Vous gardez un contrôle complet sur vos données personnelles avec des fonctionnalités intégrées directement dans votre compte."
      },
      features: {
        title: "Fonctionnalités disponibles dans votre compte",
        export: {
          title: "Exporter mes données",
          description: "Téléchargez toutes vos données au format JSON",
          location: "Disponible dans Paramètres → Données personnelles"
        },
        delete: {
          title: "Supprimer mon compte",
          description: "Suppression définitive de toutes vos données",
          location: "Disponible dans Paramètres → Gestion du compte"
        },
        view: {
          title: "Voir mes données",
          description: "Consultez toutes les informations stockées",
          location: "Disponible dans Paramètres → Confidentialité"
        },
        preferences: {
          title: "Gérer les préférences",
          description: "Contrôlez l'utilisation de vos données",
          location: "Disponible dans Paramètres → Préférences"
        }
      },
      deletionProcess: {
        title: "Processus de suppression des données",
        step1: {
          title: "Demande de suppression",
          description: "Via votre compte ou en nous contactant"
        },
        step2: {
          title: "Vérification d'identité",
          description: "Confirmation sécurisée de votre identité"
        },
        step3: {
          title: "Suppression immédiate",
          description: "Effacement définitif sous 24h maximum"
        }
      }
    },
    
    aiSecurity: {
      protection: {
        title: "IA sécurisée et privée",
        description: "Nous utilisons des modèles d'IA avancés pour analyser vos CVs, mais vos données restent <strong>privées et protégées</strong> à tout moment."
      },
      models: {
        title: "Modèles d'IA utilisés",
        openai: {
          title: "OpenAI GPT-4",
          description: "Modèle principal pour l'analyse sémantique des CVs et la comparaison avec les offres d'emploi.",
          certification: "Certifié SOC 2 Type II"
        },
        local: {
          title: "Traitement local",
          description: "Extraction de texte et pré-traitement effectués sur nos serveurs sécurisés.",
          guarantee: "Aucun stockage chez les fournisseurs IA"
        }
      },
      protectionMeasures: {
        title: "Protection des données pendant l'analyse IA",
        anonymization: {
          title: "Anonymisation automatique",
          description: "Les données personnelles identifiantes sont masquées avant l'analyse IA"
        },
        encryption: {
          title: "Transmission chiffrée",
          description: "Toutes les communications avec les services IA sont chiffrées end-to-end"
        },
        noStorage: {
          title: "Aucun stockage externe",
          description: "Les fournisseurs d'IA ne conservent aucune copie de vos données"
        },
        realtime: {
          title: "Traitement en temps réel",
          description: "Analyse immédiate sans stockage temporaire chez les tiers"
        }
      },
      purposes: {
        title: "Finalités de l'utilisation de l'IA",
        semantic: {
          title: "Analyse sémantique",
          description: "Compréhension du contenu des CVs et des offres d'emploi"
        },
        classification: {
          title: "Classification",
          description: "Classement des candidats par pertinence et adéquation"
        },
        synthesis: {
          title: "Synthèse",
          description: "Génération de résumés et recommandations personnalisées"
        }
      }
    },
    
    contact: {
      title: "Des questions sur la sécurité ?",
      subtitle: "Notre équipe sécurité est disponible pour répondre à toutes vos questions concernant la protection de vos données.",
      teamButton: "Contactez notre équipe sécurité",
      emailButton: "security@lediteur.club"
    }
  },

  // Job Application Page
  jobApplication: {
    loading: "Chargement...",
    error: {
      notFound: "Offre non trouvée",
      notFoundDescription: "Cette offre n'existe pas ou n'est plus disponible.",
      general: "Erreur lors de l'envoi",
      title: "Une erreur est survenue",
      message: "Impossible de charger cette offre. Veuillez réessayer plus tard."
    },
    success: {
      title: "Candidature envoyée !",
      description: "Merci pour votre candidature. Nous avons bien reçu votre CV et nous vous contacterons prochainement.",
      canClose: "Vous pouvez fermer cette page."
    },
    company: {
      website: "Site web",
      about: "À propos de l'entreprise"
    },
    offer: {
      views: "vues",
      publishedOn: "Publiée le",
      jobDescription: "Description du poste",
      requiredSkills: "Compétences requises"
    },
    form: {
      title: "Postuler maintenant",
      subtitle: "Rejoignez notre équipe en quelques clics",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      message: "Message (optionnel)",
      messagePlaceholder: "Pourquoi êtes-vous intéressé par ce poste ?",
      cv: "CV * (PDF ou DOCX - 10MB max)",
      cvPlaceholder: "Cliquez ou glissez votre CV ici",
      cvUploadText: "Glissez votre CV ici ou cliquez pour parcourir",
      cvFileTypes: "PDF ou DOCX (max 10MB)",
      required: "*",
      submit: "Envoyer ma candidature",
      submitting: "Envoi en cours...",
      privacy: "En soumettant ce formulaire, vous acceptez que vos données soient traitées dans le cadre de cette candidature."
    },
    validation: {
      firstNameRequired: "Le prénom est requis",
      lastNameRequired: "Le nom est requis",
      emailRequired: "L'email est requis",
      emailInvalid: "Email invalide",
      cvRequired: "Le CV est requis",
      cvFileTypeError: "Seuls les fichiers PDF ou DOCX sont acceptés. Veuillez convertir votre document avant de l'uploader.",
      cvFileSizeError: "Le fichier ne doit pas dépasser 10MB"
    },
    dateFormat: {
      options: {
        day: "numeric",
        month: "long", 
        year: "numeric"
      }
    },
    steps: {
      step: "Étape",
      of: "sur",
      personalInfo: "Informations personnelles",
      yourCV: "Votre CV",
      motivationMessage: "Message de motivation"
    },
    whyJoinUs: {
      title: "Pourquoi nous rejoindre ?",
      careerGrowth: "Évolution de carrière",
      careerGrowthDesc: "Opportunités de croissance et formation continue",
      dynamicTeam: "Équipe dynamique",
      dynamicTeamDesc: "Ambiance collaborative et bienveillante",
      innovativeProjects: "Projets innovants",
      innovativeProjectsDesc: "Travaillez sur des technologies de pointe",
      competitiveBenefits: "Avantages compétitifs",
      competitiveBenefitsDesc: "Salaire attractif et benefits"
    },
    placeholders: {
      firstName: "Jean",
      lastName: "Dupont",
      email: "jean.dupont@email.com",
      phone: "+33 6 12 34 56 78",
      motivation: "Parlez-nous de votre motivation pour ce poste..."
    },
    buttons: {
      continue: "Continuer",
      back: "Retour",
      remove: "Supprimer",
      backToHome: "Retour à l'accueil"
    },
    summary: {
      title: "Récapitulatif de votre candidature",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      cv: "CV"
    },
    expired: {
      title: "Offre expirée",
      message: "Cette offre d'emploi n'est plus disponible ou a été retirée par l'employeur."
    }
  },

  // Messages and Notifications
  messages: {
    success: {
      saved: "Paramètres enregistrés avec succès",
      updated: "Mis à jour avec succès",
      deleted: "Supprimé avec succès",
      uploaded: "Fichier téléchargé avec succès",
      sent: "Message envoyé avec succès"
    },
    errors: {
      general: "Une erreur s'est produite. Veuillez réessayer.",
      network: "Erreur réseau. Veuillez vérifier votre connexion.",
      unauthorized: "Vous n'êtes pas autorisé à effectuer cette action.",
      notFound: "La ressource demandée n'a pas été trouvée.",
      serverError: "Erreur serveur. Veuillez réessayer plus tard."
    },
    confirmations: {
      delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
      unsavedChanges: "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?",
      logout: "Êtes-vous sûr de vouloir vous déconnecter ?"
    }
  },

  // Email Templates
  emails: {
    verification: {
      subject: "Vérifiez votre compte Candio",
      title: "Bienvenue sur Candio !",
      subtitle: "Votre compte est presque prêt, il ne reste plus qu'une étape",
      description: "Le matching de CV par IA en un clic",
      thankYou: "Merci de vous être inscrit sur Candio",
      instruction: "Pour activer votre compte et commencer à utiliser nos services, veuillez cliquer sur le bouton ci-dessous :",
      buttonText: "Vérifier mon compte",
      warning: "Important : Ce lien expire dans 24 heures pour votre sécurité.",
      alternativeText: "Si le bouton ne fonctionne pas :",
      noAccount: "Si vous n'avez pas créé ce compte, vous pouvez ignorer cet email en toute sécurité.",
      copyright: "© 2025 Candio - Tous droits réservés"
    },
    contact: {
      subjectPrefix: "[Candio Contact]",
      newMessage: "Nouveau Message de Contact",
      details: "Détails du Contact",
      name: "Nom :",
      email: "Email :",
      subject: "Sujet :",
      message: "Message :",
      replyText: "Pour répondre, cliquez simplement sur 'Répondre' dans votre client email.",
      autoText: "Email envoyé automatiquement depuis Candio"
    },
    application: {
      subject: "Nouvelle candidature pour {{offerTitle}}",
      title: "Nouvelle candidature reçue",
      offerLabel: "Offre",
      candidateLabel: "Candidat",
      emailLabel: "Email",
      phoneLabel: "Téléphone", 
      messageLabel: "Message",
      noMessage: "Aucun message spécifique",
      viewAllApplicationsButton: "📋 Voir toutes les candidatures",
      dashboardFooter: "Connectez-vous à votre tableau de bord pour voir plus de détails et gérer cette candidature."
    },
    appointments: {
      invitation: {
        subject: "Invitation à un entretien - {{offerTitle}}",
        title: "Invitation à un entretien",
        greeting: "Bonjour {{candidate_name}}",
        message: "Nous avons le plaisir de vous inviter à un entretien suite à votre candidature pour le poste de \"{{offerTitle}}\".\n\nNous souhaiterions discuter avec vous de votre parcours et de vos motivations pour ce poste. Cet entretien nous permettra également de vous présenter notre entreprise et de répondre à vos questions.\n\nVous pouvez choisir un créneau qui vous convient en cliquant sur le bouton ci-dessous.",
        bookAppointment: "Prendre rendez-vous",
        meetingType: "Type de rendez-vous",
        online: "En ligne",
        physical: "En personne",
        videoLinkNote: "Le lien de visioconférence vous sera communiqué après confirmation de votre rendez-vous.",
        instructions: "Cliquez sur le bouton ci-dessus pour accéder à notre calendrier et choisir un créneau qui vous convient.",
        phone: "Tél",
        email: "Email",
        allRightsReserved: "Tous droits réservés.",
        website: "Site web",
        contact: "Contact",
        emailTitle: "Notification",
        dateLocale: "fr-FR"
      },
      confirmation: {
        subject: "Confirmation de votre rendez-vous",
        greeting: "Bonjour {{prenom}}",
        message: "Nous avons le plaisir de vous confirmer votre rendez-vous.",
        date: "Date",
        time: "Heure",
        with: "Avec",
        type: "Type",
        meetingLink: "Lien de la réunion",
        clickToJoin: "Cliquez ici pour rejoindre",
        linkWillBeSent: "Le lien vous sera envoyé prochainement",
        address: "Adresse",
        importantNote: "Note importante",
        onlineInstructions: "Assurez-vous d'avoir une connexion internet stable et un endroit calme pour votre entretien.",
        regards: "Cordialement"
      },
      cancellation: {
        subject: "Annulation de votre rendez-vous",
        greeting: "Bonjour {{prenom}}",
        message: "Nous vous informons que votre {{status_rendez_vous}} rendez-vous prévu le {{date}} à {{heure}} a été annulé.",
        reason: "Raison",
        apology: "Nous vous prions de nous excuser pour la gêne occasionnée.",
        reschedule: "Si vous souhaitez reprogrammer un rendez-vous, n'hésitez pas à nous contacter."
      }
    }
  },

  // Analyzer Page
  analyzer: {
    title: "Comparateur IA",
    subtitle: "Analysez et classez vos CVs par rapport aux offres d'emploi grâce à l'intelligence artificielle",
    
    errors: {
      dataLoadFailed: "Erreur lors du chargement des données",
      cvsLoadFailed: "Erreur lors du chargement des CVs",
      selectOfferAndCvs: "Veuillez sélectionner une offre et au moins un CV",
      maxCvsAtOnce: "Vous ne pouvez analyser que 25 CVs maximum à la fois",
      analysisError: "Erreur lors de l'analyse",
      reanalysisError: "Erreur lors de la re-analyse",
      exportError: "Erreur lors de l'export"
    },
    
    warnings: {
      maxCvsLimit: "Vous pouvez sélectionner maximum 25 CVs pour une analyse"
    },
    
    messages: {
      limitedSelection: "Sélection limitée aux 25 premiers CVs ({{count}} CVs disponibles)",
      analysisComplete: "Analyse terminée ! {{count}} CVs analysés",
      analysisCancelled: "Analyse annulée",
      exportSuccess: "Résultats exportés avec succès"
    },
    
    reanalysisModal: {
      title: "Confirmer la re-analyse",
      confirm: "Oui, refaire l'analyse",
      cancel: "Annuler",
      exactCombinationMessage: "Cette combinaison exacte ({{count}} CVs) a déjà été analysée contre cette offre le {{date}} à {{time}}.\n\nÊtes-vous sûr de vouloir refaire cette analyse identique ?",
      partialOverlapMessage: "{{analyzed}} CV(s) sur {{total}} ont déjà été analysé(s) contre cette offre (mais pas dans cette combinaison exacte).\n\nCette nouvelle combinaison permettra une classification comparative globale.\n\nÊtes-vous sûr de vouloir continuer avec cette analyse ?"
    },
    
    modes: {
      title: "Mode d'analyse",
      manual: {
        title: "Mode Manuel",
        description: "Offres non publiées + CVs uploadés manuellement"
      },
      submissions: {
        title: "Mode Candidatures",
        description: "Offres publiées + CVs reçus via candidatures"
      }
    },
    
    stats: {
      analyzed: "CVs Analysés",
      recommended: "Recommandés",
      consider: "À Considérer",
      avgScore: "Score Moyen"
    },
    
    selection: {
      selectOffer: "Sélectionner une offre",
      noOfferAvailable: "Aucune offre disponible",
      manualCvs: "CVs manuels ({{count}} sélectionnés)",
      receivedCvs: "CVs reçus pour \"{{title}}\" ({{count}} sélectionnés)",
      selectOfferFirst: "Sélectionnez une offre pour voir les CVs reçus",
      analysisStatus: "• {{analyzed}} analysés, {{unanalyzed}} non analysés",
      deselectAll: "Tout désélectionner",
      selectAll: "Tout sélectionner",
      searchPlaceholder: "Rechercher des CVs...",
      analysisStatusFilter: "Statut d'analyse:",
      filterAll: "Tous les CVs",
      filterUnanalyzed: "Non analysés",
      filterAnalyzed: "Déjà analysés",
      selectOfferToSeeCvs: "Sélectionnez une offre publiée pour voir les CVs reçus",
      noCvsAvailable: "Aucun CV manuel disponible",
      noCvsReceived: "Aucun CV reçu pour cette offre"
    },
    
    cvLabels: {
      published: "Publiée",
      manual: "Manuel",
      application: "Candidature",
      textExtracted: "Texte extrait",
      textRequired: "Texte requis",
      alreadyAnalyzed: "Déjà analysé"
    },
    
    analysisInfo: {
      limitTitle: "Limite d'analyse IA",
      limitDescription: "Vous pouvez analyser maximum 25 CVs à la fois pour garantir une analyse de qualité optimale. Pour analyser d'autres CVs de la même offre, effectuez plusieurs analyses successives.",
      startTitle: "Lancer l'analyse IA",
      startDescription: "Analyser {{count}}/25 CV(s) pour l'offre \"{{title}}\"",
      startDescriptionEmpty: "Sélectionnez une offre et des CVs pour commencer"
    },
    
    actions: {
      export: "Exporter (CSV)",
      analyzing: "Analyse en cours...",
      startAnalysisButton: "Démarrer l'analyse"
    },
    
    results: {
      title: "Résultats de l'analyse (Classés par score)",
      viewDetails: "Voir les détails",
      detailModalTitle: "Analyse détaillée - {{name}}",
      globalScore: "Score global",
      recommendation: "Recommandation",
      rank: "Rang: #{{rank}}",
      detailedAnalysis: "Analyse détaillée",
      strengths: "Points forts",
      weaknesses: "Points d'amélioration",
      close: "Fermer"
    }
  },

  // Results Page
  results: {
    title: "Résultats d'Analyse",
    
    errors: {
      dataLoadFailed: "Erreur lors du chargement des données",
      resultsLoadFailed: "Erreur lors du chargement des résultats",
      deleteFailed: "Erreur lors de la suppression",
      exportFailed: "Erreur lors de l'export"
    },
    
    messages: {
      noResults: "Aucun résultat d'analyse trouvé",
      deleteSuccess: "Résultat supprimé avec succès",
      exportSuccess: "Résultats exportés avec succès",
      exportAllNotAvailable: "Export pour toutes les offres non disponible pour le moment"
    },
    
    labels: {
      cvs: "CVs",
      topScore: "Top Score",
      recommended: "Recommandés",
      unknownCandidate: "Candidat inconnu",
      deletedCv: "CV supprimé",
      score: "Score",
      team: "Équipe",
      offer: "Offre"
    },
    
    subtitle: {
      adminWithResults: "{{count}} analyses pour {{offerCount}} offre(s)",
      adminNoOffers: "Analyses IA de votre équipe",
      hrWithResults: "{{count}} résultats d'analyses",
      hrNoResults: "Résultats d'analyses partagés avec votre équipe"
    },
    
    stats: {
      total: "Total Analysés",
      recommended: "Recommandés",
      consider: "À Considérer",
      avgScore: "Score Moyen"
    },
    
    filters: {
      offer: "Offre d'emploi",
      allOffers: "Toutes les offres",
      search: "Rechercher",
      searchPlaceholder: "Nom du CV...",
      score: "Score",
      allScores: "Tous les scores",
      excellent: "80-100 (Excellent)",
      good: "60-79 (Bon)",
      average: "40-59 (Moyen)",
      weak: "0-39 (Faible)",
      recommendation: "Recommandation",
      allRecommendations: "Toutes",
      recommended: "Recommandé",
      consider: "À considérer",
      notRecommended: "Non recommandé",
      sortBy: "Trier par",
      scoreDesc: "Score décroissant",
      scoreAsc: "Score croissant",
      newest: "Plus récent",
      oldest: "Plus ancien"
    },
    
    viewModes: {
      byOffer: "Par Offre",
      list: "Liste"
    },
    
    loading: {
      offers: "Chargement des offres...",
      results: "Chargement des résultats d'analyse..."
    },
    
    emptyStates: {
      noOffers: {
        title: "Aucune offre d'emploi",
        description: "Vous devez d'abord créer des offres d'emploi avant de pouvoir analyser des CVs."
      },
      noFilterResults: {
        title: "Aucun résultat ne correspond aux filtres",
        description: "Essayez de modifier vos filtres de recherche ou sélectionnez une autre offre."
      },
      noAnalysis: {
        title: "Aucune analyse disponible",
        descriptionAll: "Aucune analyse n'a encore été effectuée. Commencez par analyser des CVs contre vos offres.",
        descriptionSpecific: "Aucune analyse n'a été effectuée pour cette offre spécifique."
      }
    },
    
    actions: {
      refresh: "Actualiser",
      export: "Exporter (CSV)",
      exportTitle: "Exporter les résultats",
      exportNotAvailable: "Export non disponible pour toutes les offres",
      createOffer: "Créer une offre",
      analyzeCvs: "Analyser des CVs",
      viewAllAnalyses: "Voir toutes les analyses",
      viewDetails: "Voir les détails",
      delete: "Supprimer"
    },
    
    deleteModal: {
      title: "Supprimer le résultat",
      message: "Êtes-vous sûr de vouloir supprimer ce résultat d'analyse ? Cette action est irréversible.",
      confirm: "Supprimer",
      cancel: "Annuler"
    },
    
    detailModal: {
      title: "Analyse détaillée - {{filename}}",
      globalScore: "Score global",
      recommendation: "Recommandation",
      analyzedOn: "Analysé le {{date}}",
      analysisDate: "Date d'analyse",
      detailedAnalysis: "Analyse détaillée",
      strengths: "Points forts",
      weaknesses: "Points d'amélioration",
      skillsEvaluation: "Évaluation des compétences",
      skillsRadarTitle: "Analyse comparative des compétences",
      close: "Fermer"
    },
    
    radar: {
      score: "Score",
      required: "Requis",
      noData: "Aucune donnée disponible",
      candidateScore: "Score du candidat",
      jobRequirements: "Exigences du poste",
      weak: "Faible",
      medium: "Moyen",
      strong: "Fort"
    }
  },

  // Settings Page
  settings: {
    title: "Paramètres",
    subtitle: "Gérez votre profil, vos préférences et votre compte",
    
    tabs: {
      account: "Compte",
      profile: "Profil",
      password: "Mot de passe",
      preferences: "Préférences",
      company: "Entreprise",
      billing: "Paiement et facture",
      notifications: "Notifications",
      developer: "Développeur",
      usage: "Utilisation",
      cleanup: "Nettoyage automatique"
    },
    
    errors: {
      dataLoadFailed: "Erreur lors du chargement des données",
      fillAllFields: "Veuillez remplir tous les champs",
      saveError: "Erreur lors de la sauvegarde"
    },
    
    actions: {
      save: "Enregistrer",
      saving: "Enregistrement...",
      test: "Tester",
      testing: "Test en cours...",
      delete: "Supprimer",
      cancel: "Annuler",
      refresh: "Actualiser"
    },
    
    accountInfo: {
      title: "Informations du compte",
      registeredOn: "Inscrit le {{date}}",
      verified: "Compte vérifié",
      unverified: "Non vérifié",
      roles: {
        admin: "Administrateur",
        rh: "RH"
      }
    },
    
    profile: {
      title: "Informations du profil",
      fullName: "Nom complet",
      fullNamePlaceholder: "Votre nom complet",
      email: "Adresse email",
      emailPlaceholder: "votre@email.com",
      emailChangeNote: "Le changement d'email nécessitera une nouvelle vérification",
      updateSuccess: "Profil mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour du profil",
      loadError: "Erreur lors du chargement du profil",
      sync: {
        success: "Statistiques synchronisées",
        error: "Erreur lors de la synchronisation"
      },
      counters: {
        initSuccess: "Compteurs initialisés",
        initError: "Erreur lors de l'initialisation des compteurs"
      },
      usage: {
        dataUnavailable: "Données d'usage non disponibles",
        limitReached: "Limite atteinte ({{used}}/{{limit}})",
        offers: "Offres d'emploi",
        cvUploads: "CVs téléchargés",
        analyses: "Analyses IA",
        aiResume: "Résumé IA CV",
        aiResumeDesc: "Création de fiches candidats via IA",
        rhUsers: "Utilisateurs RH"
      }
    },
    
    password: {
      title: "Changer le mot de passe",
      current: "Mot de passe actuel",
      currentPlaceholder: "Votre mot de passe actuel",
      new: "Nouveau mot de passe",
      newPlaceholder: "Votre nouveau mot de passe",
      confirm: "Confirmer le nouveau mot de passe",
      confirmPlaceholder: "Confirmez votre nouveau mot de passe",
      minLengthNote: "Minimum 8 caractères",
      mismatch: "Les nouveaux mots de passe ne correspondent pas",
      minLength: "Le nouveau mot de passe doit contenir au moins 8 caractères",
      updateSuccess: "Mot de passe modifié avec succès",
      updateError: "Erreur lors du changement de mot de passe",
      changeButton: "Changer le mot de passe",
      changing: "Changement..."
    },
    
    preferences: {
      title: "Préférences",
      language: "Langue de l'interface",
      cleanupDelay: "Délai de nettoyage automatique",
      cleanupDelayNote: "Les fichiers seront automatiquement supprimés après cette période",
      emailNotifications: "Notifications par email",
      emailNotificationsNote: "Recevoir des notifications pour les analyses terminées",
      updateSuccess: "Préférences mises à jour avec succès",
      updateError: "Erreur lors de la mise à jour des préférences",
      
      // Automatic Cleanup Settings
      automaticCleanup: {
        title: "Nettoyage automatique des documents",
        subtitle: "Configurez le nettoyage automatique pour optimiser votre espace de stockage",
        enable: "Activer le nettoyage automatique",
        schedule: "Planification",
        scheduleType: {
          label: "Type de planification",
          daily: "Quotidien",
          weekly: "Hebdomadaire", 
          monthly: "Mensuel",
          custom: "Date personnalisée"
        },
        frequency: {
          label: "Fréquence",
          everyDay: "Tous les jours",
          everyXDays: "Tous les {{count}} jours"
        },
        timezone: {
          label: "Fuseau horaire",
          description: "Le nettoyage sera exécuté selon ce fuseau horaire"
        },
        dayOfWeek: {
          label: "Jour de la semaine",
          monday: "Lundi",
          tuesday: "Mardi",
          wednesday: "Mercredi",
          thursday: "Jeudi",
          friday: "Vendredi",
          saturday: "Samedi",
          sunday: "Dimanche"
        },
        dayOfMonth: {
          label: "Jour du mois",
          day: "Jour {{day}}"
        },
        time: {
          label: "Heure d'exécution",
          format: "HH:MM (24h)"
        },
        customDate: {
          label: "Date et heure",
          placeholder: "Sélectionner une date"
        },
        recurring: {
          label: "Exécution récurrente",
          yes: "Oui, répéter selon la planification",
          no: "Non, exécuter une seule fois"
        },
        cleanupOptions: {
          title: "Options de nettoyage",
          daysOld: {
            label: "Supprimer les fichiers plus anciens que",
            suffix: "jours"
          },
          fileTypes: {
            label: "Types de fichiers à nettoyer",
            manualCvs: "CVs uploadés manuellement",
            offerCvs: "CVs soumis via offres et leurs candidatures",
            results: "Résultats d'analyse IA",
            unsharedNotes: "Notes non partagées"
          },
          retentionNote: "Les fichiers plus anciens que cette durée seront supprimés"
        },
        actions: {
          save: "Enregistrer la configuration",
          saving: "Enregistrement...",
          runNow: "Lancer maintenant",
          runNowDescription: "Lancer un nettoyage manuel immédiat avec les paramètres actuels",
          running: "Nettoyage en cours...",
          cancel: "Annuler"
        },
        jobHistory: {
          title: "Historique des nettoyages",
          noHistory: "Aucun historique disponible",
          columns: {
            filesDeleted: "Fichiers supprimés",
            spaceFreed: "Espace libéré"
          },
          status: {
            pending: "En attente",
            processing: "En cours",
            completed: "Terminé",
            failed: "Échoué",
            retry: "Nouvelle tentative"
          },
          details: {
            manual: "Manuel",
            scheduled: "Planifié",
            filesDeleted: "{{count}} fichier(s) supprimé(s)",
            spaceFreed: "{{size}} libéré(s)",
            duration: "Durée: {{time}}",
            error: "Erreur: {{message}}"
          }
        },
        success: {
          saved: "Configuration de nettoyage enregistrée",
          started: "Nettoyage démarré avec succès"
        },
        confirmRunNow: "Êtes-vous sûr de vouloir lancer un nettoyage manuel maintenant ?",
        error: {
          save: "Erreur lors de l'enregistrement",
          start: "Erreur lors du démarrage du nettoyage",
          load: "Erreur lors du chargement de la configuration"
        }
      }
    },
    
    company: {
      title: "Paramètres entreprise",
      subtitle: "Configurez les informations de votre entreprise qui apparaîtront sur les pages publiques des offres d'emploi.",
      name: "Nom de l'entreprise",
      namePlaceholder: "Nom de votre entreprise",
      nameNote: "Ce nom apparaîtra sur les pages publiques des offres d'emploi",
      industry: "Secteur d'activité",
      industryPlaceholder: "Technologie, Santé, Finance...",
      selectIndustry: "Sélectionner un secteur",
      logo: {
        title: "Logo de l'entreprise",
        current: "Logo actuel :",
        change: "Changer le logo",
        upload: "Uploader un logo",
        formats: "PNG, JPG, GIF, WebP jusqu'à 5MB",
        note: "Le logo apparaîtra en en-tête des pages publiques des offres d'emploi. Recommandé : format carré ou rectangle horizontal, fond transparent.",
        newSelected: "✓ Nouveau fichier sélectionné: {{name}}",
        remove: "Supprimer",
        invalidFormat: "Format de fichier non supporté. Utilisez JPG, PNG, GIF ou WebP.",
        tooLarge: "Le fichier est trop volumineux. Taille maximum : 5MB.",
        alt: "Logo entreprise"
      },
      preview: {
        title: "Aperçu sur les pages publiques :",
        placeholder: "Nom de l'entreprise"
      },
      updateSuccess: "Paramètres entreprise mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour des paramètres entreprise"
    },
    
    notifications: {
      mainTitle: "Notifications",
      mainSubtitle: "Configurez qui doit être notifié par email pour les différents événements de la plateforme.",
      updateSuccess: "Paramètres de notifications mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour des notifications",
      applications: {
        title: "Notifications de candidatures",
        description: "Recevoir des notifications lors de nouvelles candidatures sur vos offres publiées.",
        enabled: "Activer les notifications de candidatures",
        notifyPublisher: "Notifier le créateur de l'offre",
        notifyPublisherNote: "Le créateur de chaque offre recevra les notifications",
        customUsers: "Utilisateurs à notifier en plus",
        customUsersNote: "Ces utilisateurs recevront toutes les notifications de candidatures"
      },
      appointments: {
        title: "Notifications de rendez-vous",
        description: "Recevoir des notifications lors de réservations de créneaux par les candidats.",
        enabled: "Activer les notifications de rendez-vous",
        notifyRecruiter: "Notifier le recruteur concerné",
        notifyRecruiterNote: "Le recruteur recevra les notifications pour ses rendez-vous",
        customUsers: "Utilisateurs à notifier en plus",
        customUsersNote: "Ces utilisateurs recevront toutes les notifications de rendez-vous"
      },
      analyses: {
        title: "Notifications d'analyses terminées",
        description: "Recevoir des notifications lorsqu'une analyse de CVs est terminée.",
        enabled: "Activer les notifications d'analyses",
        notifyExecutor: "Notifier l'exécuteur de l'analyse",
        notifyExecutorNote: "L'utilisateur qui lance l'analyse recevra la notification",
        customUsers: "Utilisateurs à notifier en plus",
        customUsersNote: "Ces utilisateurs recevront toutes les notifications d'analyses"
      },
      noHrUsers: "Aucun utilisateur RH disponible",
      summary: {
        title: "Résumé de la configuration",
        publisherNotified: "Le créateur de chaque offre sera notifié",
        recruiterNotified: "Le recruteur concerné sera notifié",
        executorNotified: "L'exécuteur sera notifié",
        customUsersNotified: "{{count}} utilisateur(s) supplémentaire(s)",
        allDisabled: "⚠️ Toutes les notifications sont désactivées"
      },
      // Legacy fields for backward compatibility
      title: "Notifications candidatures",
      subtitle: "Configurez qui doit être notifié par email lors de la réception de nouvelles candidatures via les offres publiées.",
      enabled: "Notifications par email activées",
      enabledNote: "Activer/désactiver toutes les notifications de candidatures",
      defaultConfig: "Configuration par défaut",
      notifyPublisher: "Notifier le créateur de l'offre",
      notifyPublisherNote: "Par défaut, celui qui publie une offre reçoit les notifications pour cette offre",
      customUsers: "Utilisateurs à notifier en plus",
      customUsersNote: "Sélectionnez les utilisateurs RH qui doivent recevoir les notifications pour toutes les candidatures"
    },
    
    usage: {
      title: "Utilisation et limites",
      currentPlan: "Package actuel",
      refresh: "Actualiser les données",
      expiresOn: "Expire le {{date}}",
      notDefined: "Non défini",
      infiniteLimit: "∞",
      tips: {
        title: "Conseils d'utilisation",
        resetMonthly: "• Les limites se réinitialisent chaque mois",
        deleteOldCvs: "• Supprimez les anciens CVs pour libérer de l'espace",
        autoCleanup: "• Utilisez le nettoyage automatique pour optimiser le stockage",
        contactSupport: "• Contactez le support pour augmenter vos limites"
      }
    },
    
    minio: {
      title: "Stockage MinIO Personnalisé",
      subtitle: "Configurez votre propre serveur MinIO pour un contrôle total de vos données",
      warning: {
        title: "⚠️ Avertissement Important",
        technical: "• Cette fonctionnalité est réservée aux administrateurs techniques",
        ownership: "• Vous êtes responsable de votre infrastructure MinIO et de sa sécurité",
        costs: "• L'hébergement MinIO peut entraîner des coûts supplémentaires (serveur, stockage, sauvegardes)",
        misconfiguration: "• Une mauvaise configuration peut rendre vos fichiers inaccessibles"
      },
      status: {
        title: "Statut actuel",
        hasConfig: "Configuration sauvegardée",
        noConfig: "Pas de configuration",
        enabled: "Stockage actif",
        disabled: "Stockage Candio par défaut",
        migration: "Migration: {{status}}"
      },
      config: {
        title: "Configuration MinIO",
        endpoint: "Endpoint",
        endpointPlaceholder: "minio.votre-domaine.com",
        port: "Port",
        useSSL: "Utiliser SSL",
        accessKey: "Access key",
        secretKey: "Secret key",
        publicUrl: "URL publique (optionnel)",
        defaultBucket: "Bucket par défaut",
        systemBucket: "Bucket système",
        testConnection: "Tester la connexion",
        configure: "Configurer le stockage MinIO",
        save: "Sauvegarder",
        configSaved: "Configuration sauvegardée",
        configuredOn: "Configuré le",
        dateUnknown: "Date inconnue",
        enable: "Activer",
        disable: "Désactiver",
        delete: "Supprimer"
      },
      errors: {
        fillAllFields: "Veuillez remplir tous les champs obligatoires"
      },
      testSuccess: "Configuration MinIO valide ! ✅",
      testFailed: "Configuration MinIO invalide",
      testError: "Erreur lors du test de la configuration",
      saveSuccess: "Configuration MinIO sauvegardée avec succès ! 🎉",
      saveError: "Erreur lors de la sauvegarde de la configuration",
      enabled: "Configuration MinIO activée !",
      disabled: "Configuration MinIO désactivée !",
      toggleError: "Erreur lors du changement de statut",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer votre configuration MinIO personnalisée ?",
      deleteSuccess: "Configuration MinIO supprimée !",
      deleteError: "Erreur lors de la suppression",
      migration: {
        title: "Migration des données",
        description: "Vous pouvez migrer vos données existantes entre le stockage Candio par défaut et votre stockage MinIO personnalisé.",
        estimate: "Estimer la migration",
        toCustom: "Migrer vers mon stockage",
        fromCustom: "Revenir au stockage Candio",
        toCustomConfirm: "Êtes-vous sûr de vouloir migrer vos données vers votre stockage MinIO personnalisé ? Cette opération peut prendre du temps.",
        fromCustomConfirm: "Êtes-vous sûr de vouloir migrer vos données vers le stockage Candio par défaut ? Cette opération peut prendre du temps.",
        toCustomStarted: "Migration démarrée en arrière-plan ! 🚀",
        fromCustomStarted: "Migration de retour démarrée en arrière-plan ! 🔄",
        startError: "Erreur lors du démarrage de la migration",
        estimateError: "Erreur lors de l'estimation",
        estimateTitle: "Estimation de migration",
        totalFiles: "Fichiers à migrer",
        totalSize: "Taille totale",
        duration: "Durée estimée: {{duration}}",
        inProgress: "Migration en cours",
        status: "Statut:",
        files: "fichiers",
        none: "aucune"
      }
    },

    aiProviders: {
      title: "Fournisseurs IA",
      subtitle: "Configurez vos clés API pour activer les analyses et résumés IA",
      openai: {
        title: "OpenAI",
        description: "Clé API pour les résumés et analyses IA."
      },
      anthropic: {
        title: "Anthropic",
        description: "Clé API pour les analyses avancées via Claude."
      },
      apiKey: "Clé API",
      apiKeyPlaceholder: "sk-...",
      save: "Enregistrer",
      delete: "Supprimer",
      confirmTitle: "Supprimer la clé API",
      updatedAt: "Mis à jour le {{date}}",
      tokenPreview: "Clé enregistrée : {{token}}",
      loading: "Chargement...",
      note: "Si aucune clé n'est définie, le système utilisera les clés globales configurées par Candio.",
      confirmDelete: "Supprimer cette clé API ?",
      messages: {
        saved: "Clé API enregistrée",
        deleted: "Clé API supprimée"
      },
      errors: {
        required: "Veuillez renseigner une clé API valide",
        saveFailed: "Erreur lors de la sauvegarde",
        deleteFailed: "Erreur lors de la suppression"
      }
    },
    
    jobs: {
      title: "Jobs en arrière-plan",
      noJobs: "Aucun job en cours",
      progress: "Progression",
      created: "Créé le {{date}} à {{time}}",
      attempts: "Tentative {{current}}/{{max}}",
      error: "Erreur:",
      storageMigration: "Migration stockage",
      storageCleanup: "Nettoyage stockage",
      fileTransfer: "Transfert de fichiers",
      unknown: "Type inconnu",
      refresh: "Actualiser",
      loading: "Chargement..."
    },
    
    developer: {
      title: "Configuration Développeur",
      techInfo: {
        title: "Informations techniques",
        containers: "• Vos fichiers sont stockés dans des buckets MinIO privés dédiés au workspace",
        structure: "• La structure des dossiers suit le format: cvs/, logos/, photos/",
        security: "• Les accès sont sécurisés par des URLs signées temporaires",
        migration: "• La migration peut prendre du temps selon le volume de données",
        background: "• Les migrations s'exécutent en arrière-plan pour ne pas bloquer l'application"
      }
    },
    
    cleanup: {
      title: "Nettoyage automatique",
      subtitle: "Configurez le nettoyage automatique des fichiers et données obsolètes"
    },
    
    billing: {
      title: "Paiement et facture",
      subtitle: "Gérez vos méthodes de paiement et consultez vos factures.",
      error: {
        load: "Erreur lors du chargement des données de facturation",
        portalUrl: "Impossible d'accéder au portail de facturation"
      },
      
      paymentMethods: {
        title: "Méthodes de paiement",
        subtitle: "Gérez vos cartes de crédit et moyens de paiement",
        manage: "Gérer",
        expires: "Expire",
        default: "Par défaut",
        noMethods: "Aucune méthode de paiement enregistrée",
        addMethod: "Ajouter une méthode de paiement"
      },
      
      invoices: {
        title: "Factures",
        subtitle: "Historique de vos factures et paiements",
        date: "Date",
        plan: "Plan",
        amount: "Montant",
        statusColumn: "Statut",
        status: {
          paid: "Payée",
          pending: "En attente",
          failed: "Échouée"
        },
        actions: "Actions",
        download: "Télécharger",
        downloadSuccess: "Facture téléchargée avec succès",
        downloadError: "Erreur lors du téléchargement de la facture",
        noInvoices: "Aucune facture disponible",
        subscription: "Abonnement"
      }
    }
  },

  // HR Management Page (Gestion RH)
  rh: {
    title: "Gestion RH",
    subtitle: "Gérez les comptes utilisateurs RH de votre équipe",
    noUsers: "Aucun utilisateur trouvé",
    createFirst: "Commencez par ajouter un utilisateur RH",
    searchPlaceholder: "Rechercher un utilisateur...",
    addUser: "Ajouter un utilisateur RH",
    
    // Dashboard stats
    stats: {
      hrUsers: "Utilisateurs RH",
      totalAnalyses: "Analyses totales", 
      createdOffers: "Offres créées",
      uploadedCvs: "CVs uploadés",
      activeAccounts: "Comptes activés",
      inactiveAccounts: "Comptes non activés"
    },
    
    // License information
    license: {
      title: "Informations de licence",
      currentPackage: "Package actuel",
      status: "Statut",
      expiration: "Expiration",
      active: "Active",
      inactive: "Inactive",
      notDefined: "Non défini",
      notDefinedDate: "Non définie"
    },
    
    // Filters
    filters: {
      allStatuses: "Tous les statuts",
      verified: "Vérifiés",
      unverified: "Non vérifiés"
    },
    
    // Table headers
    table: {
      user: "Utilisateur",
      email: "Email",
      status: "Statut",
      createdDate: "Date de création",
      actions: "Actions"
    },
    
    // User status
    userStatus: {
      verified: "Vérifié",
      unverified: "Non vérifié",
      hrUser: "Utilisateur RH",
      nameNotDefined: "Nom non défini"
    },
    
    // Pagination
    pagination: {
      previous: "Précédent",
      next: "Suivant",
      showing: "Affichage de",
      to: "à",
      of: "sur",
      results: "résultats"
    },
    
    // Search and filters help text
    searchHelp: {
      modifySearch: "Essayez de modifier vos critères de recherche"
    },
    
    // Modals
    modals: {
      add: {
        title: "Ajouter un utilisateur RH",
        fullName: "Nom complet",
        emailAddress: "Adresse email",
        password: "Mot de passe",
        namePlaceholder: "Nom de l'utilisateur",
        emailPlaceholder: "email@exemple.com",
        passwordPlaceholder: "Mot de passe (min. 8 caractères)",
        verificationNote: "Un email de vérification sera envoyé à l'utilisateur",
        cancel: "Annuler",
        create: "Créer l'utilisateur",
        creating: "Création..."
      },
      edit: {
        title: "Modifier l'utilisateur",
        fullName: "Nom complet",
        emailAddress: "Adresse email",
        newPassword: "Nouveau mot de passe (optionnel)",
        emailNote: "Changer l'email réinitialisera la vérification",
        passwordPlaceholder: "Laisser vide pour ne pas modifier",
        cancel: "Annuler",
        update: "Mettre à jour",
        updating: "Mise à jour..."
      },
      delete: {
        title: "Supprimer l'utilisateur",
        confirmText: "Êtes-vous sûr de vouloir supprimer l'utilisateur",
        warningText: "Cette action est irréversible. L'utilisateur ne pourra plus accéder à son compte.",
        cancel: "Annuler",
        delete: "Supprimer",
        deleting: "Suppression..."
      }
    },
    
    // Action tooltips
    tooltips: {
      resendVerification: "Renvoyer l'email de vérification",
      edit: "Modifier",
      delete: "Supprimer"
    },
    
    // Toast messages
    messages: {
      loadError: "Erreur lors du chargement des données",
      fillAllFields: "Veuillez remplir tous les champs",
      fillNameEmail: "Veuillez remplir le nom et l'email",
      passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
      userCreated: "Utilisateur RH créé avec succès",
      createError: "Erreur lors de la création de l'utilisateur",
      userUpdated: "Utilisateur mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour",
      userDeleted: "Utilisateur supprimé avec succès",
      deleteError: "Erreur lors de la suppression",
      alreadyVerified: "L'utilisateur est déjà vérifié",
      verificationSent: "Email de vérification envoyé à",
      emailError: "Erreur lors de l'envoi de l'email"
    }
  },

  // Appointments system
  appointments: {
    title: "Prise de rendez-vous",
    subtitle: "Gérez vos rendez-vous et configurez vos disponibilités",
    
    // Navigation tabs
    tabs: {
      calendar: "Mon calendrier",
      calendarDesc: "Visualisez et gérez vos rendez-vous",
      availability: "Disponibilités & Congés",
      availabilityDesc: "Créneaux horaires et jours fériés",
      settings: "Paramètres",
      settingsDesc: "Durée des RDV, délais, URL de réservation",
      templates: "Gabarits email",
      templatesDesc: "Personnalisez vos emails de rendez-vous",
      holidays: "Jours fériés",
      holidaysDesc: "Gérez vos jours de fermeture",
      video: "Visioconférence",
      videoDesc: "Configurez vos outils de réunion"
    },
    
    // Status
    status: {
      pending: "En attente",
      confirmed: "Confirmé",
      cancelled: "Annulé"
    },
    
    // Filters
    filters: {
      upcoming: "À venir",
      confirmed: "Confirmés",
      cancelled: "Annulés"
    },
    
    // Calendar component
    calendar: {
      today: "Aujourd'hui",
      viewDay: "Jour",
      viewWeek: "Semaine",
      viewMonth: "Mois",
      previous: "Précédent",
      next: "Suivant",
      scopeMy: "Mon calendrier",
      scopeTeam: "Calendrier d'équipe",
      filterRecruiter: "Filtrer",
      filterAll: "Tous les recruteurs",
      recruiter: "Recruteur",
      densityComfortable: "Confort",
      densityCompact: "Compact",
      appointmentDetails: "Détails du rendez-vous",
      candidate: "Candidat",
      online: "En ligne",
      physical: "Physique",
      joinMeeting: "Rejoindre la réunion",
      cancellationReason: "Raison de l'annulation",
      confirm: "Confirmer",
      cancel: "Annuler",
      cancelReason: "Raison de l'annulation (optionnel):",
      bookingUrl: "Votre lien de réservation",
      dayView: "Rendez-vous du",
      appointment: "rendez-vous",
      appointments: "rendez-vous",
      inPerson: "En personne",
      noAppointments: "Aucun rendez-vous pour cette date",
      error: {
        fetch: "Erreur lors du chargement des rendez-vous",
        confirm: "Erreur lors de la confirmation",
        cancel: "Erreur lors de l'annulation",
        forbidden: "Vous n'avez pas accès à ces rendez-vous",
        noVideoAdmin: "Veuillez configurer votre outil de réunion dans Paramètres > Intégration réunions.",
        noVideoUser: "Veuillez contacter votre administrateur pour activer l'intégration des outils de visioconférence.",
        urlRequired: "Veuillez fournir l'URL de la réunion"
      },
      manualUrlRequired: "Veuillez fournir l'URL de la réunion",
      urlHint: "Cette URL sera envoyée au candidat dans l'email de confirmation",
      success: {
        confirm: "Rendez-vous confirmé avec succès",
        cancel: "Rendez-vous annulé",
        copyUrl: "Lien copié dans le presse-papier"
      },
      modalTip: "Cliquez sur un rendez-vous ou sur l'icône œil pour accéder à la gestion détaillée de la réservation"
    },
    
    // Recent invitations
    recentInvitations: {
      title: "Derniers rendez-vous envoyés",
      refreshed: "Liste actualisée",
      empty: "Aucune invitation envoyée récemment",
      sentOn: "Envoyé le",
      error: {
        fetch: "Erreur lors du chargement des invitations"
      }
    },
    
    // Availability settings
    availability: {
      title: "Mes disponibilités",
      description: "Configurez vos créneaux de disponibilité pour chaque jour de la semaine",
      days: {
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche"
      },
      add: "Ajouter une disponibilité",
      addSlot: "Ajouter un créneau",
      noSlots: "Aucun créneau configuré",
      noneForDay: "Aucune disponibilité",
      confirmDelete: "Voulez-vous vraiment supprimer cette disponibilité ?",
      confirmDeleteTitle: "Supprimer la disponibilité",
      error: {
        fetch: "Erreur lors du chargement des disponibilités",
        add: "Erreur lors de l'ajout",
        delete: "Erreur lors de la suppression",
        toggle: "Erreur lors de la modification"
      },
      success: {
        add: "Disponibilité ajoutée avec succès",
        delete: "Disponibilité supprimée avec succès",
        toggle: "Créneau modifié"
      },
      confirm: {
        delete: "Êtes-vous sûr de vouloir supprimer ce créneau ?"
      }
    },
    
    // Booking settings
    settings: {
      title: "Paramètres de réservation",
      description: "Configurez les règles de prise de rendez-vous",
      systemStatus: "Système de réservation",
      statusDescription: "Activez ou désactivez les réservations en ligne",
      statusActive: "Les candidats peuvent prendre rendez-vous",
      statusInactive: "Les réservations sont temporairement désactivées",
      configTitle: "Configuration des créneaux",
      configDescription: "Définissez la durée et les règles de planification",
      duration: "Durée des rendez-vous",
      durationHelp: "Durée standard pour chaque rendez-vous",
      bufferTime: "Temps de pause entre RDV",
      bufferHelp: "Pause automatique entre chaque rendez-vous",
      noBreak: "Pas de pause",
      minAdvance: "Délai minimum de réservation",
      minAdvanceHelp: "Temps de préavis minimum avant un RDV",
      maxAdvance: "Réservation possible jusqu'à",
      maxAdvanceHelp: "Période maximale pour réserver à l'avance",
      timezone: "Fuseau horaire",
      timezoneInfo: "Tous vos créneaux seront affichés dans ce fuseau horaire",
      useDetected: "Utiliser votre fuseau horaire détecté",
      autoSaving: "Sauvegarde automatique...",
      active: "Activer la prise de rendez-vous en ligne",
      urlTitle: "URL de réservation",
      urlDescription: "Personnalisez votre lien de prise de rendez-vous",
      customUrl: "URL personnalisée",
      generateUrl: "Générer une URL aléatoire",
      checkingAvailability: "Vérification de la disponibilité...",
      urlTaken: "Cette URL est déjà utilisée",
      urlAvailable: "Cette URL est disponible",
      yourUrl: "Votre lien de réservation",
      preview: "Aperçu",
      error: {
        fetch: "Erreur lors du chargement des paramètres",
        save: "Erreur lors de l'enregistrement",
        generateSlug: "Erreur lors de la génération"
      },
      success: {
        save: "Paramètres enregistrés avec succès",
        copy: "Lien copié dans le presse-papier"
      }
    },
    
    // Email templates
    templates: {
      title: "Gabarits d'emails",
      description: "Personnalisez les emails envoyés automatiquement",
      types: {
        invitation: "Invitation à prendre rendez-vous",
        invitationDesc: "Email envoyé aux candidats pour les inviter à réserver un créneau",
        confirmation: "Confirmation de rendez-vous",
        confirmationDesc: "Email envoyé automatiquement après confirmation du RDV",
        cancellation: "Annulation de rendez-vous",
        cancellationDesc: "Email envoyé en cas d'annulation du RDV"
      },
      availableVars: "Variables disponibles",
      subject: "Objet",
      body: "Corps du message",
      reset: "Réinitialiser",
      preview: "Aperçu",
      previewTitle: "Aperçu de l'email",
      previewNote: "Ceci est un aperçu avec des données d'exemple",
      error: {
        fetch: "Erreur lors du chargement des gabarits",
        save: "Erreur lors de l'enregistrement",
        reset: "Erreur lors de la réinitialisation",
        preview: "Erreur lors de la prévisualisation"
      },
      success: {
        save: "Gabarit enregistré avec succès",
        reset: "Gabarit réinitialisé"
      },
      confirm: {
        reset: "Êtes-vous sûr de vouloir réinitialiser ce gabarit ?"
      }
    },
    
    // Video Configuration Alert
    videoConfigAlert: {
      title: "Configuration vidéo requise",
      message: "Pour permettre les rendez-vous en ligne, configurez un service de visioconférence.",
      configure: "Configurer maintenant"
    },
    
    // System email templates (for AdminLanguageContext)
    systemEmailTemplates: {
      invitation: {
        title: "Invitation à un entretien",
        greeting: "Bonjour {{candidate_name}},",
        intro: "Nous vous remercions pour votre candidature et souhaitons vous rencontrer pour discuter de votre profil.",
        interviewDetails: "Détails de l'entretien",
        recruiter: "Recruteur",
        position: "Poste",
        company: "Entreprise",
        duration: "Durée",
        type: "Type",
        schedulingInfo: "Pour planifier votre entretien, veuillez cliquer sur le lien ci-dessous et choisir un créneau qui vous convient :",
        bookingButton: "Choisir un créneau horaire",
        importantInfo: "Informations importantes :",
        confirmationNote: "Vous recevrez une confirmation par email après avoir choisi votre créneau",
        onlineNote: "Le lien de visioconférence vous sera envoyé dans l'email de confirmation",
        physicalNote: "L'adresse exacte vous sera communiquée dans l'email de confirmation",
        regards: "Cordialement,",
        team: "L'équipe {{company_name}}"
      },
      confirmation: {
        title: "Confirmation de rendez-vous",
        greeting: "Bonjour {{candidate_name}},",
        confirmed: "Votre rendez-vous a été confirmé !",
        details: "Détails du rendez-vous",
        date: "Date",
        time: "Heure",
        duration: "Durée",
        type: "Type",
        recruiter: "Recruteur",
        onlineInstructions: "Votre rendez-vous aura lieu en ligne. Rejoignez la réunion en cliquant sur le lien ci-dessous :",
        joinButton: "Rejoindre la réunion",
        physicalInstructions: "Votre rendez-vous aura lieu à l'adresse suivante :",
        preparation: "Préparation",
        prepTips: "N'hésitez pas à préparer vos questions et à relire votre CV.",
        reschedule: "Si vous devez reporter ce rendez-vous, veuillez nous contacter dans les plus brefs délais.",
        regards: "Cordialement,",
        team: "L'équipe {{company_name}}"
      },
      cancellation: {
        title: "Annulation de rendez-vous",
        greeting: "Bonjour {{candidate_name}},",
        cancelled: "Votre rendez-vous a été annulé",
        reason: "Raison",
        noReason: "Aucune raison spécifiée",
        reschedule: "Si vous souhaitez reprogrammer un entretien, n'hésitez pas à nous contacter.",
        contact: "Vous pouvez nous joindre à l'adresse suivante :",
        apologies: "Nous nous excusons pour la gêne occasionnée.",
        regards: "Cordialement,",
        team: "L'équipe {{company_name}}"
      },
      reminder: {
        title: "Rappel de rendez-vous",
        greeting: "Bonjour {{candidate_name}},",
        reminder: "Nous vous rappelons que vous avez un rendez-vous prévu",
        when: "{{relative_time}}",
        details: "Détails du rendez-vous",
        preparation: "Préparation suggérée",
        prepTips: "Relisez votre CV et préparez vos questions sur le poste et l'entreprise.",
        onlineReminder: "Le lien de visioconférence est disponible ci-dessous :",
        joinButton: "Rejoindre la réunion",
        physicalReminder: "Adresse du rendez-vous :",
        regards: "Cordialement,",
        team: "L'équipe {{company_name}}"
      },
      recruiterNotification: {
        title: "Nouveau rendez-vous réservé",
        greeting: "Bonjour {{recruiter_name}},",
        newBooking: "Un nouveau rendez-vous a été réservé",
        candidateInfo: "Informations du candidat",
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        subject: "Objet",
        appointmentDetails: "Détails du rendez-vous",
        date: "Date",
        time: "Heure",
        duration: "Durée",
        type: "Type",
        action: "Action requise",
        confirmReminder: "N'oubliez pas de confirmer ce rendez-vous depuis votre calendrier pour que le candidat reçoive le lien de visioconférence.",
        dashboardButton: "Accéder au tableau de bord",
        regards: "Cordialement,",
        system: "Le système Candio"
      }
    },
    
    // Public booking page (for AdminLanguageContext)
    publicBooking: {
      title: "Prendre rendez-vous avec",
      selectDate: "Sélectionnez une date",
      selectTime: "Choisissez un créneau",
      noSlots: "Aucun créneau disponible",
      selectOtherDate: "Veuillez sélectionner une autre date",
      meetingType: "Type de rendez-vous",
      online: "En ligne",
      onlineDesc: "Visioconférence",
      physical: "Physique",
      physicalDesc: "Rendez-vous en personne",
      yourInfo: "Vos informations",
      name: "Nom complet",
      namePlaceholder: "Jean Dupont",
      email: "Email",
      emailPlaceholder: "jean.dupont@email.com",
      phone: "Téléphone",
      phonePlaceholder: "+33 6 12 34 56 78",
      subject: "Objet du rendez-vous",
      subjectPlaceholder: "Entretien pour le poste de...",
      book: "Réserver",
      booking: "Réservation en cours...",
      successTitle: "Rendez-vous confirmé !",
      successMessage: "Vous recevrez un email de confirmation dans quelques instants.",
      errorTitle: "Erreur",
      errorMessage: "Une erreur est survenue. Veuillez réessayer.",
      notFound: "Page de réservation introuvable",
      notActive: "Les réservations ne sont pas activées pour ce recruteur",
      required: "Champ requis",
      invalidEmail: "Email invalide",
      duration: "Durée",
      minutes: "minutes",
      today: "Aujourd'hui",
      tomorrow: "Demain",
      loading: "Chargement...",
      meetingTypeFixed: "Le type de rendez-vous a été défini par le recruteur"
    },
    
    
    // Holiday settings
    holidays: {
      title: "Jours fériés et fermetures",
      description: "Définissez les jours où vous n'êtes pas disponible",
      add: "Ajouter un jour férié",
      none: "Aucun jour férié défini",
      initialize: "Initialiser",
      date: "Date",
      name: "Nom",
      namePlaceholder: "Nom du jour férié",
      recurring: "Récurrent",
      recurringBadge: "Récurrent",
      global: "Pour toute l'équipe",
      empty: "Aucun jour férié configuré",
      legendGlobal: "Jour férié global",
      legendPersonal: "Jour férié personnel",
      confirmDelete: "Voulez-vous vraiment supprimer ce jour férié ?",
      confirmDeleteTitle: "Supprimer le jour férié",
      error: {
        fetch: "Erreur lors du chargement des jours fériés",
        add: "Erreur lors de l'ajout",
        delete: "Erreur lors de la suppression",
        required: "Veuillez remplir tous les champs",
        nameRequired: "Le nom du jour férié est requis",
        initialize: "Erreur lors de l'initialisation"
      },
      success: {
        add: "Jour férié ajouté avec succès",
        delete: "Jour férié supprimé avec succès",
        initialize: "{{count}} jours fériés ajoutés"
      },
      confirm: {
        delete: "Êtes-vous sûr de vouloir supprimer ce jour férié ?",
        deleteTitle: "Supprimer le jour férié",
        initialize: "Voulez-vous initialiser les jours fériés français par défaut ?"
      }
    },
    
    // Video conference settings
    video: {
      title: "Configuration de la visioconférence",
      description: "Configurez votre outil de réunion pour les rendez-vous en ligne",
      adminOnly: "Configuration administrateur",
      adminOnlyDesc: "Ces paramètres s'appliquent à tous les utilisateurs du workspace",
      adminOnlyTitle: "Accès administrateur requis",
      adminOnlyMessage: "Seuls les administrateurs peuvent configurer les paramètres de visioconférence.",
      provider: "Fournisseur de visioconférence",
      apiConfig: "Configuration API",
      generalSettings: "Paramètres généraux",
      defaultDuration: "Durée par défaut",
      timezone: "Fuseau horaire",
      active: "Activer la visioconférence pour les rendez-vous",
      configured: "(Configuré)",
      configuredNote: "Pour des raisons de sécurité, les valeurs sensibles ne sont pas affichées. Saisissez de nouvelles valeurs uniquement si vous souhaitez les modifier.",
      enterValue: "Entrez la valeur",
      instructions: "Instructions de configuration",
      fields: {
        api_key: "Clé API",
        api_secret: "Secret API",
        refresh_token: "Token de rafraîchissement",
        webhook_secret: "Secret Webhook",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        accountId: "Account ID",
        tenantId: "Tenant ID",
        botToken: "Bot Token",
        appId: "App ID"
      },
      testMeeting: "Tester la création",
      authorizeGoogle: "Autoriser Google Meet",
      googleAuthorized: "Google Meet est autorisé et prêt à être utilisé",
      meetInstructions: "Google Meet génère automatiquement des liens. Aucune configuration API requise.",
      meetInstructions1: "Accédez à Google Cloud Console",
      meetInstructions2: "Créez un nouveau projet ou sélectionnez-en un existant",
      meetInstructions3: "Activez Google Calendar API et Google Meet API",
      meetInstructions4: "Créez des identifiants OAuth 2.0",
      meetInstructions5: "Ajoutez les URI de redirection autorisés",
      zoomInstructions1: "Connectez-vous à votre compte Zoom Marketplace",
      zoomInstructions2: "Créez une app OAuth Server-to-Server",
      zoomInstructions3: "Ajoutez les scopes meeting:write et meeting:read",
      zoomInstructions4: "Copiez l'Account ID, Client ID et Client Secret",
      teamsInstructions1: "Accédez à Azure Active Directory",
      teamsInstructions2: "Enregistrez une nouvelle application",
      teamsInstructions3: "Configurez les permissions: OnlineMeetings.ReadWrite",
      teamsInstructions4: "Créez un secret client",
      teamsInstructions5: "Notez le Tenant ID et Client ID",
      slackInstructions1: "Créez une app Slack",
      slackInstructions2: "Ajoutez les scopes: calls:write, calls:read",
      slackInstructions3: "Installez l'app dans votre workspace",
      slackInstructions4: "Copiez le Bot User OAuth Token",
      error: {
        fetch: "Erreur lors du chargement des paramètres",
        save: "Erreur lors de l'enregistrement",
        delete: "Erreur lors de la suppression",
        noProvider: "Veuillez sélectionner un fournisseur",
        missingFields: "Veuillez remplir tous les champs requis",
        googleAuth: "Erreur lors de l'authentification Google",
        googleCallback: "Erreur lors de l'authentification",
        testMeeting: "Erreur lors du test"
      },
      success: {
        save: "Paramètres enregistrés avec succès",
        delete: "Configuration supprimée",
        googleAuth: "Google Meet authentifié avec succès",
        testMeeting: "Réunion de test créée avec succès"
      },
      confirm: {
        deleteTitle: "Supprimer la configuration",
        delete: "Êtes-vous sûr de vouloir supprimer cette configuration ?"
      },
      
      subtitle: "Configurez votre outil de visioconférence préféré pour les rendez-vous en ligne",
      save: "Enregistrer la configuration",
      saving: "Enregistrement...",
      warning: {
        noProvider: "Aucun outil de visioconférence configuré",
        configure: "Veuillez configurer au moins un outil pour permettre les rendez-vous en ligne."
      },
      providers: {
        google_meet: {
          description: "Utilisez Google Meet pour vos entretiens vidéo"
        },
        zoom: {
          description: "Créez des réunions Zoom pour vos rendez-vous"
        },
        teams: {
          description: "Organisez des réunions Microsoft Teams"
        },
        slack: {
          description: "Utilisez Slack Huddles pour vos entretiens"
        }
      },
      setup: {
        title: "Configuration requise",
        description: "Pour activer cette intégration, vous devez créer une application dans la console développeur du service.",
        link: "Accéder à la console développeur"
      }
    },
    
    // Appointment invitation modal
    invite: {
      title: "Envoyer une invitation",
      subtitle: "Inviter {{name}} à prendre rendez-vous",
      meetingType: "Type de rendez-vous",
      physical: "Physique",
      physicalDesc: "Rendez-vous en personne",
      online: "En ligne",
      onlineDesc: "Visioconférence",
      emailPreview: "Aperçu de l'email",
      subject: "Objet",
      body: "Message",
      sendTo: "Envoyer à",
      position: "Poste",
      send: "Envoyer l'invitation",
      error: {
        noUrl: "Veuillez configurer votre URL de réservation dans les paramètres",
        noType: "Veuillez sélectionner le type de rendez-vous",
        noVideoAdmin: "Veuillez configurer votre outil de réunion dans Paramètres > Intégration réunions.",
        noVideoUser: "Veuillez contacter votre administrateur pour activer l'intégration des outils de visioconférence.",
        send: "Erreur lors de l'envoi de l'invitation"
      },
      warning: {
        noVideoAdmin: "Attention : Aucun outil de visioconférence configuré. Configurez-le dans les paramètres.",
        noVideoUser: "Attention : La visioconférence n'est pas configurée. Contactez votre administrateur."
      }
    },
    
    // Send appointment modal
    sendModal: {
      title: "Envoyer une invitation de rendez-vous",
      bookingActive: "Vos réservations sont activées",
      bookingInactive: "Réservations non activées",
      bookingUrl: "URL de réservation",
      bookingNotConfigured: "URL de réservation non configurée",
      configureBookingUrl: "Vous devez configurer et activer votre URL de réservation dans les paramètres avant d'envoyer des invitations",
      goToSettings: "Aller aux paramètres",
      activateBooking: "Activez les réservations dans les paramètres pour permettre aux candidats de prendre rendez-vous",
      meetingType: "Type de rendez-vous",
      letCandidateChoose: "Laisser choisir",
      candidateWillChoose: "Le candidat choisira",
      online: "En ligne",
      physical: "Physique",
      noVideoConfig: "Aucun service de visioconférence configuré",
      configureNow: "Configurer maintenant",
      candidateName: "Nom du candidat",
      candidateNamePlaceholder: "Jean Dupont",
      candidateEmail: "Email du candidat",
      candidateEmailPlaceholder: "jean.dupont@email.com",
      subject: "Objet",
      subjectPlaceholder: "Invitation pour un entretien",
      message: "Message personnalisé",
      messagePlaceholder: "Bonjour, nous aimerions vous rencontrer pour discuter de votre candidature...",
      infoTitle: "Information importante :",
      info1: "Si vous choisissez le type de rendez-vous, le candidat ne pourra pas le modifier",
      info2: "Si vous laissez le candidat choisir, il pourra sélectionner entre en ligne et physique",
      info3: "Pour les rendez-vous en ligne, assurez-vous d'avoir configuré un service de visioconférence",
      send: "Envoyer l'invitation",
      success: "Invitation envoyée avec succès",
      errors: {
        missingInfo: "Veuillez remplir tous les champs obligatoires",
        bookingNotConfigured: "L'URL de réservation n'est pas configurée. Veuillez la configurer dans les paramètres.",
        noVideoConfig: "Veuillez configurer un service de visioconférence ou indiquer que l'URL sera fournie manuellement",
        invalidEmail: "L'email du candidat est invalide.",
        invalidMeetingType: "Le type de rendez-vous est invalide.",
        invalidOffer: "L'offre sélectionnée est invalide.",
        invalidCv: "Le CV sélectionné est invalide.",
        sendFailed: "Erreur lors de l'envoi de l'invitation"
      },
      manualUrlRequired: "Vous devrez fournir manuellement l'URL de la réunion lors de la confirmation du rendez-vous.",
      confirmManualUrl: "Je fournirai l'URL de la réunion manuellement",
      configureAuto: "Configurer la génération automatique",
      videoConfigured: "Visioconférence configurée",
      autoUrlGeneration: "L'URL de la réunion sera générée automatiquement lors de la confirmation."
    },
    
    // Backend error messages
    errors: {
      // General
      providerAlreadyConfigured: "Un fournisseur de visioconférence est déjà configuré. Veuillez supprimer la configuration existante avant d'en configurer une nouvelle.",
      rateLimited: "Trop de requêtes. Veuillez réessayer dans quelques minutes.",
      serverError: "Erreur serveur",
      missingInfo: "Informations manquantes",
      invalidData: "Données invalides",
      notFound: "Non trouvé",
      unauthorized: "Non autorisé",
      
      // Booking errors
      bookingNotFound: "Page de réservation non trouvée",
      bookingNotActive: "Les réservations ne sont pas activées pour ce recruteur",
      datesRequired: "Dates requises",
      slotNotAvailable: "Ce créneau n'est plus disponible",
      bookingCreationError: "Erreur lors de la création du rendez-vous",
      invalidToken: "Token invalide ou déjà utilisé",
      appointmentAlreadyCancelled: "Token invalide ou rendez-vous déjà annulé",
      
      // Availability errors
      invalidTimeFormat: "Format d'heure invalide. Utilisez HH:MM",
      endTimeBeforeStart: "L'heure de fin doit être après l'heure de début",
      invalidDayOfWeek: "Le jour de la semaine doit être entre 0 et 6",
      overlappingSlots: "Ce créneau chevauche avec des créneaux existants",
      availabilityNotFound: "Disponibilité non trouvée",
      availabilityFetchError: "Erreur lors de la récupération des disponibilités",
      availabilityCreateError: "Erreur lors de la création de la disponibilité",
      availabilityUpdateError: "Erreur lors de la modification de la disponibilité",
      availabilityDeleteError: "Erreur lors de la suppression de la disponibilité",
      
      // Video conference errors
      invalidProvider: "Provider invalide. Choisir parmi: zoom, meet, teams, slack",
      videoNotConfigured: "La visioconférence n'est pas configurée pour ce workspace",
      zoomKeysNotConfigured: "Les clés API Zoom ne sont pas configurées",
      unsupportedProvider: "Provider de visioconférence non supporté",
      meetingLinkError: "Erreur lors de la génération du lien de réunion",
      videoSettingsFetchError: "Erreur lors de la récupération des paramètres",
      videoSettingsSaveError: "Erreur lors de la sauvegarde des paramètres",
      videoSettingsDeleteError: "Erreur lors de la suppression de la configuration",
      
      // Settings errors
      slugAlreadyTaken: "Cette URL est déjà utilisée",
      invalidDuration: "Durée invalide",
      invalidSlug: "URL invalide",
      settingsFetchError: "Erreur lors du chargement des paramètres",
      settingsSaveError: "Erreur lors de l'enregistrement des paramètres",
      
      // Holiday errors
      holidayNameRequired: "Le nom du jour férié est requis",
      holidayNotFound: "Jour férié non trouvé",
      holidayAlreadyExists: "Un jour férié existe déjà à cette date",
      holidayFetchError: "Erreur lors du chargement des jours fériés",
      holidayCreateError: "Erreur lors de l'ajout du jour férié",
      holidayDeleteError: "Erreur lors de la suppression du jour férié",
      
      // Appointment errors
      appointmentNotFound: "Rendez-vous non trouvé",
      appointmentFetchError: "Erreur lors du chargement des rendez-vous",
      appointmentConfirmError: "Erreur lors de la confirmation du rendez-vous",
      appointmentCancelError: "Erreur lors de l'annulation du rendez-vous",
      meetingUrlRequired: "L'URL de la réunion est requise",
      adminVideoConfigRequired: "Veuillez configurer votre outil de réunion dans Paramètres > Intégration réunions.",
      userVideoConfigRequired: "Veuillez contacter votre administrateur pour activer l'intégration des outils de visioconférence.",
      
      // Send invitation errors
      noBookingUrl: "Veuillez configurer votre URL de réservation dans les paramètres",
      invitationSendError: "Erreur lors de l'envoi de l'invitation",
      candidateNotFound: "Candidat non trouvé",
      
      // Email errors
      emailSendError: "Erreur lors de l'envoi de l'email",
      templateFetchError: "Erreur lors du chargement des gabarits",
      templateSaveError: "Erreur lors de l'enregistrement du gabarit",
      templateResetError: "Erreur lors de la réinitialisation du gabarit"
    }
  },

  // Super Admin
  superadmin: {
    dashboard: {
      title: "Tableau de bord Super Admin",
      subtitle: "Vue d'ensemble de la plateforme CV Analyzer",
      newUsers7d: "Nouveaux utilisateurs (7 jours)",
      envConfigured: "Variables configurées",
      modulesTitle: "Modules plateforme",
      analyses: "analyses"
    },
    stats: {
      totalUsers: "Total Utilisateurs",
      administrators: "Administrateurs",
      activeSubscriptions: "Abonnements Actifs",
      admins: "admins",
      rh: "RH"
    },
    admins: {
      title: "Gestion des Administrateurs",
      subtitle: "Cliquez sur un administrateur pour voir ses utilisateurs RH",
      rhUsers: "utilisateurs RH",
      plan: "Plan"
    },
    users: {
      title: "Gestion des Utilisateurs",
      subtitle: "Gérer les administrateurs et leurs collaborateurs RH",
      searchPlaceholder: "Rechercher par nom ou email",
      resultsCount: "Résultats",
      noResults: "Aucun administrateur trouvé",
      rhUsersTitle: "Utilisateurs RH",
      noRhUsers: "Aucun utilisateur RH rattaché à cet administrateur",
      activate: "Activer",
      deactivate: "Désactiver",
      delete: "Supprimer",
      deleteBlocked: "Supprimez d'abord les RH rattachés à cet administrateur",
      deleteConfirmTitle: "Supprimer l'utilisateur",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer {{userName}} ? Cette action est définitive.",
      stats: {
        admins: "Admins",
        activeAdmins: "Admins actifs",
        rhUsers: "Utilisateurs RH",
        activeRh: "RH actifs"
      }
    },
    actions: {
      userManagement: "Gestion utilisateurs",
      userDescription: "Gérer les admins et les RH",
      variables: "Variables d’environnement",
      variablesDescription: "Configurer les clés runtime critiques",
      analytics: "Analytiques",
      analyticsDescription: "Statistiques détaillées de la plateforme"
    },
    community: {
      title: "Liste communauté",
      subtitle: "Emails collectés depuis la section publique de lancement",
      searchPlaceholder: "Rechercher par email",
      empty: "Aucun email trouvé",
      stats: {
        total: "Total emails",
        newLast7Days: "7 derniers jours"
      },
      table: {
        email: "Email",
        language: "Langue",
        source: "Source",
        createdAt: "Créé le"
      },
      errors: {
        load: "Erreur lors du chargement de la liste communauté"
      }
    },
    errors: {
      loadStats: "Erreur lors du chargement des statistiques",
      loadAdmins: "Erreur lors du chargement des administrateurs",
      updateStatus: "Erreur lors de la modification du statut",
      deleteUser: "Erreur lors de la suppression"
    },
    success: {
      statusUpdated: "Statut utilisateur mis à jour",
      userDeleted: "Utilisateur supprimé avec succès"
    },
    confirm: {
      deleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?"
    },
    env: {
      title: "Variables d’environnement",
      subtitle: "Configurez les clés critiques (Stockage, IA, Email).",
      categories: {
        urls: "URLs",
        core: "Core",
        storage: "Stockage Candio",
        email: "Email systeme",
        ai: "IA",
        video: "Video",
        other: "Autres"
      },
      labels: {
        secret: "Secret",
        plain: "Public"
      },
      actions: {
        add: "Ajouter",
        showValue: "Afficher la valeur",
        hideValue: "Masquer la valeur"
      },
      search: "Rechercher",
      searchPlaceholder: "Rechercher une clé ou description...",
      fields: {
        key: "Clé",
        selectKey: "Sélectionner une clé",
        value: "Valeur",
        category: "Catégorie"
      },
      status: {
        configured: "Configurée",
        missing: "Manquante"
      },
      stats: {
        total: "Total des variables",
        configured: "Configurées",
        missing: "Manquantes",
        secret: "Clés secrètes"
      },
      empty: "Aucune variable trouvée pour ce filtre",
      table: {
        key: "Clé",
        category: "Catégorie",
        status: "Statut",
        preview: "Valeur",
        actions: "Actions"
      },
      modal: {
        create: "Ajouter une variable",
        edit: "Modifier la variable",
        helper: "Configurer une variable d’environnement critique"
      },
      errors: {
        load: "Erreur lors du chargement des variables",
        loadSingle: "Impossible de charger la variable",
        missing: "Clé et valeur sont obligatoires",
        save: "Erreur lors de la sauvegarde",
        delete: "Erreur lors de la suppression"
      },
      success: {
        saved: "Variable enregistrée",
        updated: "Variable mise à jour",
        deleted: "Variable supprimée",
        refreshed: "Variables actualisées"
      },
      confirmTitle: "Confirmation de suppression",
      confirmDelete: "Supprimer cette variable ? Cette action est irréversible.",
      groupSummary: "Public : {{public}} • Secret : {{secret}}"
    }
  },

  // Usage limit check messages
  limitCheck: {
    reason: "Vous avez atteint la limite de votre plan ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    cvUploadReason: "Limite atteinte pour les uploads de CV ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    cvUploadBatchExceeded: "Limite atteinte pour les uploads de CV. Vous pouvez uploader {{available}} CV(s) sur {{requested}} demandé(s). ({{used}}/{{limit}} utilisés)",
    resumeAiReason: "Vous avez atteint la limite de résumés AI ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    analysisReason: "Vous avez atteint la limite d'analyses ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    offersReason: "Vous avez atteint la limite d'offres ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    rhUsersReason: "Vous avez atteint la limite d'utilisateurs RH ({{used}}/{{limit}}). Veuillez passer à un plan supérieur pour continuer.",
    used: "{{count}} utilisé(s)",
    limit: "Limite : {{count}}",
    remaining: "{{count}} restant(s)",
    allowed: "Autorisé"
  },

  // CV Preview
  cvPreview: {
    title: "Aperçu CV",
    addedOn: "Ajouté le",
    poweredBy: "Aperçu PDF • Powered by PDF.js",
    zoomOut: "Zoom arrière",
    zoomIn: "Zoom avant",
    resetZoom: "Réinitialiser zoom",
    docxFile: "Fichier DOCX",
    docxNotSupported: "La prévisualisation directe des fichiers DOCX n'est pas encore disponible.",
    docxPreview: "Aperçu du contenu DOCX",
    loading: "Chargement...",
    loadingPdf: "Chargement du PDF...",
    retrying: "Nouvelle tentative...",
    retry: "Réessayer",
    downloadCta: "Télécharger le CV",
    extractedContent: "Contenu extrait :",
    textNotExtracted: "Le texte n'a pas encore été extrait de ce fichier.",
    downloadFile: "Télécharger le fichier",
    oldDocFormat: "Fichier DOC (ancien format)",
    oldDocNotSupported: "La prévisualisation des fichiers .DOC n'est pas supportée. Veuillez télécharger le fichier pour le consulter.",
    unsupportedFormat: "Format non supporté",
    unsupportedMessage: "Ce type de fichier ne peut pas être prévisualisé.",
    errors: {
      loadFailed: "Impossible de charger le PDF",
      pdfCorrupted: "Le fichier PDF est corrompu ou invalide",
      pdfJsUnavailable: "PDF.js n'est pas disponible",
      network: "Erreur de réseau lors du chargement du PDF",
      passwordProtected: "Ce PDF est protégé par un mot de passe",
      configuration: "Erreur de configuration PDF.js - Veuillez réessayer",
      fileAccess: "Impossible d'accéder au fichier PDF sur le serveur",
      generic: "Erreur de chargement : {{message}}"
    }
  },

  // Candidate Modal
  candidateModal: {
    title: {
      edit: "Modifier le candidat",
      create: "Créer une fiche candidat"
    },
    subtitle: "Complétez la fiche candidat avec un profil clair et actionnable pour le pipeline RH.",
    sections: {
      identity: "Identité",
      positioning: "Positionnement"
    },
    fields: {
      photo: "Photo",
      photoHelp: "PNG, JPG, GIF jusqu'à 5MB",
      firstName: "Prénom",
      lastName: "Nom",
      title: "Titre / Profil",
      specialty: "Spécialité",
      score: "Score (0-100)",
      careerSummary: "Résumé du parcours",
      strengths: "Points forts",
      weaknesses: "Points d'amélioration"
    },
    placeholders: {
      title: "Ex: Développeur Full Stack Senior",
      specialty: "Ex: React, Node.js, AWS",
      careerSummary: "Décrivez brièvement le parcours professionnel du candidat...",
      strengths: "Listez les principaux atouts du candidat...",
      weaknesses: "Identifiez les axes d'amélioration potentiels..."
    },
    buttons: {
      cancel: "Annuler",
      create: "Créer",
      update: "Mettre à jour",
      saving: "Enregistrement..."
    },
    success: {
      created: "Candidat créé avec succès",
      updated: "Candidat mis à jour"
    },
    errors: {
      photoSize: "La photo ne doit pas dépasser 5 MB",
      saveFailed: "Erreur lors de la sauvegarde"
    }
  },

  // AI configuration guard
  aiConfig: {
    modal: {
      title: "Configuration IA requise",
      message: "Les tokens des fournisseurs IA ne sont pas configurés. Ajoutez vos clés API dans Paramètres > Développeur > Fournisseurs IA.",
      goToSettings: "Aller aux paramètres",
      cancel: "Fermer"
    },
    errors: {
      invalidToken: "Clé API IA invalide. Veuillez vérifier vos tokens dans Paramètres > Développeur > Fournisseurs IA."
    }
  },

  // License
  license: {
    expired: {
      message: "Votre licence a expiré. Renouvelez votre abonnement pour continuer à utiliser toutes les fonctionnalités.",
      rhMessage: "Le plan de votre administrateur a expiré. Veuillez contacter votre administrateur pour renouveler l'abonnement.",
      renew: "Renouveler"
    }
  },

  // Payment
  payment: {
    success: {
      planUpdated: "Plan mis à jour vers {{planName}} !",
      processed: "Paiement traité avec succès !",
      subscriptionActivated: "Abonnement activé avec succès !"
    },
    processing: {
      finalizing: "Finalisation de votre abonnement...",
      finalInProgress: "Finalisation en cours... Veuillez patienter quelques instants.",
      updateInProgress: "Mise à jour en cours... Veuillez rafraîchir la page dans quelques instants."
    },
    error: {
      syncError: "Erreur de synchronisation. Veuillez actualiser la page."
    }
  },

  // Beta Launch Modal
  betaLaunch: {
    title: "Plan Bêta Disponible Bientôt",
    message: "Actuellement, seul le plan démo est disponible.",
    comingSoon: "Les plans payants seront activés dans quelques jours !",
    feedback: "Vos commentaires et suggestions sont très appréciés et nous aident à améliorer Candio.",
    contact: "Nous Contacter"
  }
};
